// cSpell:ignore aanmaken afrekening afrekening's Alles Annuleren bedrag Beheer beschrijving betaald Betaalopdrachten betaalopdrachten betaling Eenheid eigenaar forfait Gedeeld Gelijk Gelijke Groepslaan herstellingen Huurder huurder innen keer kost laste leverancier Nieuwe Onmiddellijke onmiddellijke Opslaan pand pand's panden panden's rekenen sleutel Stap taksen unbilled Unstored verbruik verdeelsleutel Verdeelsleutel verdelen Verdeling verdeling Verdelingsmethode verzekering Verzenden verzonden Volgende voor Vorige vragen Wijzigen
import { isPerformingSubmitActionSelector } from "@rentiohq/shared-frontend/dist/forms/createPayment/schema.createPayment.actions";
import { logError } from "@rentiohq/shared-frontend/dist/logger/logger";
import { EErrorType } from "@rentiohq/shared-frontend/dist/logger/logger.types";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import * as documentActions from "@rentiohq/shared-frontend/dist/reduxV2/documents/document.actions";
import * as documentApi from "@rentiohq/shared-frontend/dist/reduxV2/documents/document.api";
import * as propertyHooks from "@rentiohq/shared-frontend/dist/reduxV2/property/property.hooks";
import {
  EDocumentCategory,
  EDocumentMemberTypes,
} from "@rentiohq/shared-frontend/dist/types/document.types";
import { EPropertyMemberTypes } from "@rentiohq/shared-frontend/dist/types/property.types";
import { confirm } from "@rentiohq/shared-frontend/dist/utils/confirm.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { formatNumber } from "@rentiohq/shared-frontend/dist/utils/number.utils";
import { getMembersWithRole } from "@rentiohq/shared-frontend/dist/utils/roles.utils";
import {
  Banner,
  Button,
  DisplayText,
  DropdownMenu,
  Icon,
  Labelled,
  Modal,
  OptionListShared,
  SegmentedControl,
  Select,
  Stack,
  TextField,
  TextStyle,
} from "@rentiohq/web-shared/dist/components";
import { PropertySelectInline } from "@rentiohq/web-shared-next/dist/ui-components";
import { FontWeights } from "@rentiohq/web-theme";
import React, { useMemo, useRef, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { UNSAFE_NavigationContext } from "react-router-dom";
import { PaymentForm as PaymentFormContainer } from "scenes/Properties/scenes/Payments/scenes-v2/PaymentForm";
import styled, { createGlobalStyle } from "styled-components";
import { isCostOccupancyKnown, proposedChargeFor } from "../chargeTarget.utils";
import {
  buildCostDistribution,
  createMissingCosts,
  getLeasesOfSplitsToBill,
  hasMixedOwners,
  IBilledSplit,
  withBilledSplits,
  withoutPaymentLinks,
} from "../costPayment.utils";
import {
  isCostPeriodTooLong,
  MAX_COST_PERIOD_YEARS,
} from "../costPeriod.utils";
import { ICostDepartureShare } from "../costSettlementState.utils";
import {
  prorationVatParties,
  splitInvoiceEqually,
  splitInvoiceVat,
  supplierVatByLease,
  TCostBilling,
} from "../costVat.utils";
import { buildingBreakdown, prorateByOccupancy } from "../engine";
import { fixedFeeLeaseIds } from "../fixedFeeBilling.utils";
import {
  IAddressParts,
  unitAddressLabel,
  unitsExistingSince,
} from "../groupUnits.utils";
import {
  useGroupRentalContractsState,
  useGroupUnits,
  useKeys,
  usePropertyOwners,
  usePropertyRentalContracts,
} from "../hooks";
import { keyDisplayName } from "../keyName.utils";
import {
  costPaymentOf,
  NO_OWN_VAT,
  OUTGOING_VAT_RATES,
  TOutgoingVat,
} from "../leaseVat.utils";
import { todayIsoDay } from "../localDay.utils";
import {
  fromCents,
  roundCents,
  splitEqually,
  sumInCents,
  tenantShareCents,
  toCents,
  vatOfAmount,
} from "../money.utils";
import { formatMoney, vatLineText } from "../moneyText.utils";
import { MONEY_DECIMALS, PERCENTAGE_DECIMALS } from "../numberInput.utils";
import {
  canPayPerOwner,
  getNextOpenRunIndex,
  getOwnerPayRuns,
  groupSharesByOwner,
  ownerGroupsSentence,
} from "../ownerPayGroups.utils";
import {
  getBillablePayerIds,
  getLeasePayer,
  getPayerName,
  getPayerOptionLabel,
  hasPayerChoice,
  IPayerCandidate,
  joinRecipientNames,
  joinRecipientNamesAmong,
} from "../payer.utils";
import {
  IReadingOccupant,
  prorationByReadings,
  readingOccupantsOf,
  unitReadingOf,
} from "../readingSplit.utils";
import {
  installLeaveGuard,
  ITraversalNavigation,
} from "../scenes/SettlementInfo/SettlementForm/leaveGuard.utils";
import {
  getNextOpenShareIndex,
  ICreatedOrderLinks,
  linkCreatedOrders,
} from "../scenes/SettlementInfo/SettlementForm/SettlementForm.utils";
import { PeriodPresetTabs } from "../scenes/SettlementInfo/SettlementForm/steps/StepPeriod";
import { confirmLeave } from "../scenes/SettlementInfo/SettlementForm/useLeaveGuard";
import {
  CATEGORY_META,
  Category,
  ContractRef,
  Invoice,
  InvoiceTarget,
  isOwnerOnlyCategory,
  PaymentSplit,
  sortedCategoryOptions,
  VAT_OPTIONS,
  VatValue,
  vatLabel,
  vatPercent,
} from "../types";
import { KeyModal } from "./ApportionmentKeysTab";
import {
  BuildingDistribution,
  KeyCoverageWarning,
} from "./BuildingDistribution";
import { IsoDateField } from "./IsoDateField";
import { LocaleNumberField } from "./LocaleNumberField";
import { Money, moneyFont } from "./Money";
import { OwnerGroupList } from "./OwnerGroupList";
import { DistTotal, UnitDistribution } from "./UnitDistribution";

const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const UploadZone = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1.5px dashed ${({ theme }) => theme.getColor("gray", 400)};
  border-radius: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme.getColor("gray", 600)};
  font-size: 14px;
  &:hover {
    border-color: ${({ theme }) => theme.getColor("primary")};
    color: ${({ theme }) => theme.getColor("gray", 1000)};
  }
`;

const UploadedFile = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid ${({ theme }) => theme.getColor("gray", 200)};
  border-radius: 8px;
  font-size: 14px;
  color: ${({ theme }) => theme.getColor("gray", 1000)};
  .name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .remove {
    cursor: pointer;
    color: ${({ theme }) => theme.getColor("gray", 600)};
  }
`;

// A step's title sits 16 px above what follows, as in the settlement
// wizard (Lewis, 2026-10-21). Inside a Stack the Stack's own gap (8 px tight,
// 24 px loose) already counts towards that.
const STEP_TITLE_GAP = 16;
const STACK_GAP = { tight: 8, loose: 24 };

const StepTitle = styled.div<{ $inStack?: keyof typeof STACK_GAP }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ $inStack }) =>
    STEP_TITLE_GAP - ($inStack ? STACK_GAP[$inStack] : 0)}px;
  .left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .count {
    font-size: 14px;
    color: ${({ theme }) => theme.getColor("gray", 600)};
  }
`;

const SplitHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 16px 0 8px;
  .left {
    font-size: 13px;
    color: ${({ theme }) => theme.getColor("gray", 600)};
  }
  .total {
    font-size: 15px;
  }
  .total strong {
    font-weight: ${FontWeights.Bold};
    ${moneyFont}
  }
`;

// Amount + "+ € btw" subdued — mirrors the row style in the Verdeling step
// (DistBlock .amt / .btw) so the cost amount reads identically across screens.
const AmountStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  margin-top: -4px;
  font-variant-numeric: tabular-nums;
  .amt {
    font-size: 14px;
    font-weight: ${FontWeights.SemiBold};
    color: ${({ theme }) => theme.getColor("gray", 1000)};
  }
  .btw {
    font-size: 12px;
    color: ${({ theme }) => theme.getColor("gray", 600)};
    ${moneyFont}
  }
`;

const UnitRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.getColor("gray", 200)};
  &:last-child {
    border-bottom: 0;
  }
  .name {
    flex: 1;
    font-size: 14px;
    font-weight: ${FontWeights.SemiBold};
    color: ${({ theme }) => theme.getColor("gray", 1000)};
  }
  .pct {
    font-size: 13px;
    color: ${({ theme }) => theme.getColor("gray", 600)};
    min-width: 64px;
  }
  .field {
    width: 150px;
  }
`;

// The legacy web-shared Modal sits at z-index 99999; lift the MUI Autocomplete
// dropdown (PropertySelectInline) above it so it isn't hidden behind the modal.
const AutocompletePopperFix = createGlobalStyle`
  .MuiAutocomplete-popper { z-index: 100001 !important; }
`;

const SelectedRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.getColor("gray", 200)};
  &:last-child {
    border-bottom: 0;
  }
  .icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.getColor("gray", 0)};
  }
  .body {
    flex: 1;
    min-width: 0;
  }
  .name {
    font-size: 14px;
    color: ${({ theme }) => theme.getColor("gray", 1000)};
  }
  .role {
    font-size: 12px;
    color: ${({ theme }) => theme.getColor("gray", 600)};
    margin-top: 1px;
  }
  .kebab {
    cursor: pointer;
    color: ${({ theme }) => theme.getColor("gray", 600)};
  }
`;

const BreakdownRow = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid ${({ theme }) => theme.getColor("gray", 200)};
  &:last-child {
    border-bottom: 0;
  }
  .pand {
    font-size: 14px;
    font-weight: ${FontWeights.Bold};
    color: ${({ theme }) => theme.getColor("gray", 1000)};
    margin-bottom: 10px;
  }
  .cols {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 16px;
    align-items: end;
  }
  .total {
    text-align: right;
    min-width: 120px;
  }
  .total .lbl {
    font-size: 12px;
    color: ${({ theme }) => theme.getColor("gray", 600)};
  }
  .total .val {
    font-size: 15px;
    font-weight: ${FontWeights.Bold};
    color: ${({ theme }) => theme.getColor("gray", 1000)};
    ${moneyFont}
  }
  .total .btw {
    font-size: 12px;
    color: ${({ theme }) => theme.getColor("gray", 600)};
    ${moneyFont}
  }
`;

// The intro of the cost's split: under readings each occupant pays their
// own consumption, never by their days (M30).
const distributionNoteKey = (params: {
  isBuildingCost: boolean;
  distributionMethod: string;
}): string => {
  if (!params.isBuildingCost) return "costs.modal.distribution_note_unit";
  if (params.distributionMethod === "consumption") {
    return "costs.modal.distribution_note_readings";
  }
  return "costs.modal.distribution_note_building";
};

export interface AssignProperty {
  id: string;
  code: string;
  address?: string;
  type?: "unit" | "building";
  // A unit's box and its address without it, for its full address with the
  // box spelled out (unitAddressLabel).
  box?: string;
  addressParts?: IAddressParts;
}

export interface InvoiceModalProps {
  properties: AssignProperty[];
  // When set, the invoice is fixed to this single property and the assignment
  // step is skipped (the property is already implied — e.g. adding from a property).
  fixedPropertyId?: string;
  // When set, the modal edits this invoice (single property, assignment skipped).
  initialInvoice?: Invoice;
  // The departed tenants' shares of the edited cost that departure
  // settlements already settled (see costSettlementState.utils). The edit
  // leaves those shares as they are; the cost stays bound for the settlement.
  departureShares?: ICostDepartureShare[];
  // Already-registered costs, to warn (non-blocking) about a likely duplicate:
  // same supplier + same amount + same period.
  existingInvoices?: Invoice[];
  // Persists the cost(s) and resolves with them as stored: while a direct
  // cost's tenants are billed one by one, the popup stores the cost after the
  // first payment and adds every later one to it (via onUpdate). Neither
  // callback closes the popup: the modal owns when to close (via onClose).
  onClose: () => void;
  onSaveMany: (
    payloads: Omit<Invoice, "id">[],
  ) => Promise<Invoice[] | void> | void;
  // Gets the whole cost, only the changed invoice details of a cost whose
  // payment was already requested, or the payment splits of a cost whose
  // tenants are being billed.
  onUpdate?: (
    id: string,
    payload: Partial<Omit<Invoice, "id">>,
  ) => Promise<void> | void;
}

// The share of a single pand whose tenants are not known (no contracts loaded):
// the payment form then asks who pays, with the rent payer preselected.
const UNKNOWN_TENANT_SHARE_ID = "unknown-tenant";
const NO_CREATED_ORDERS: ICreatedOrderLinks = {
  orderByContract: {},
  requestByContract: {},
  payerByContract: {},
};

const MAX_PERCENTAGE = 100;
// What the cost columns hold (rentio-api-next refuses more): the amount is a
// DECIMAL(14,7), supplier and own category name are VARCHAR(255).
const MAX_COST_AMOUNT = 9_999_999.99;
const MAX_COST_TEXT_LENGTH = 255;
const PERCENTAGE_FACTOR = 10 ** PERCENTAGE_DECIMALS;

// The tenant share that bills `value` of `total`, rounded to the two decimals
// a share keeps (so € 100 of € 300 is 33,33%, which bills € 99,99).
const sharePctForAmount = (params: { value: number; total: number }) =>
  Math.round(
    (params.value / params.total) * MAX_PERCENTAGE * PERCENTAGE_FACTOR,
  ) / PERCENTAGE_FACTOR;

// Payment descriptions only allow letters, digits and spaces (no accents).
const sanitizeDescription = (s: string) =>
  s
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

type ChargeTarget = "tenant" | "owner" | "shared";
type SettlementMethod = "direct" | "settlement" | "paid";
type StepKey =
  | "info"
  | "assignment"
  | "settlementMethod"
  | "distributionMethod"
  | "distribution"
  | "paymentOrders"
  | "payment";

const chargeTargetFromTarget = (t: InvoiceTarget): ChargeTarget => {
  if (t === "owner") return "owner";
  if (t === "shared") return "shared";
  return "tenant";
};
// "paid" lives in the settlementMethod list: a paid cost is settled, so no
// immediate payment request and no annual settlement.
const settlementMethodFromInvoice = (inv: Invoice): SettlementMethod | null => {
  if (inv.paidAt) return "paid";
  if (inv.target === "direct") return "direct";
  if (inv.target === "settlement" || inv.target === "shared")
    return "settlement";
  return null;
};

// ── Distribution method picker for a group cost ─────────────────────────────
// Wraps the three-way split (sleutel / verbruik / bedrag) with the extra input
// each method needs: unit-dropdown + per-unit meter reading for consumption,
// per-unit EUR input with a running-remainder validator for amount. The labels
// are the settlement wizard's own, so a method has one name everywhere.
const METHOD_KEYS: Record<"key" | "consumption" | "amount", string> = {
  key: "costs.distribution_method.key",
  consumption: "costs.distribution_method.consumption",
  amount: "costs.distribution_method.company",
};
const CONSUMPTION_UNITS: {
  id: "kwh" | "m3";
  label: string;
}[] = [
  { id: "m3", label: "m³" },
  { id: "kwh", label: "kWh" },
];

// Per-pand card list — one row per unit with its name on the left and the
// numeric input on the right, stacked vertically so long unit labels never
// wrap alongside the input.
const UnitList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const UnitCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  border: 1px solid ${({ theme }) => theme.getColor("gray", 200)};
  border-radius: 8px;
  background: ${({ theme }) => theme.getColor("white")};
  .name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    font-weight: ${FontWeights.SemiBold};
    color: ${({ theme }) => theme.getColor("gray", 1000)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .field {
    width: 180px;
    flex: 0 0 180px;
  }
`;

// Top-row layout: Verdelingsmethode dropdown + secondary picker
// (Verdeelsleutel or Eenheid) side-by-side. The columns hold a select only and
// grow with the room there is, so both selects line up and a longer French
// placeholder does not wrap.
const MethodTopRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  align-items: flex-start;
  & > * {
    flex: 1 1 240px;
    min-width: 220px;
  }
`;

const RemainderNotice = styled.div<{ $ok: boolean }>`
  padding: 10px 12px;
  border-radius: 6px;
  margin-top: 8px;
  background: ${({ theme, $ok }) =>
    $ok ? theme.getColor("green", 0) : theme.getColor("yellow", 0)};
  color: ${({ theme, $ok }) =>
    $ok ? theme.getColor("green", 800) : theme.getColor("gray", 1000)};
  font-size: 13px;
`;

const MethodPicker: React.FC<{
  distributionMethod: "key" | "consumption" | "amount";
  setDistributionMethod: (m: "key" | "consumption" | "amount") => void;
  units: { id: string; label: string }[];
  totalAmount: number;
  consumptionUnit: "kwh" | "m3";
  setConsumptionUnit: (u: "kwh" | "m3") => void;
  consumptionByUnit: Record<string, number>;
  setConsumptionByUnit: (v: Record<string, number>) => void;
  // Per unit, its occupants in the cost's period: a reading each (Y15).
  readingOccupantsByUnit?: Record<string, IReadingOccupant[]>;
  amountByUnit: Record<string, number>;
  setAmountByUnit: (v: Record<string, number>) => void;
  keyPicker: React.ReactNode;
  // Shown under the selects (e.g. "Nieuwe verdeelsleutel"), so it does not
  // push one select lower than the other.
  keyActions?: React.ReactNode;
}> = ({
  distributionMethod,
  setDistributionMethod,
  units,
  totalAmount,
  consumptionUnit,
  setConsumptionUnit,
  consumptionByUnit,
  setConsumptionByUnit,
  readingOccupantsByUnit = {},
  amountByUnit,
  setAmountByUnit,
  keyPicker,
  keyActions,
}) => {
  const methodOptions = (
    Object.keys(METHOD_KEYS) as ("key" | "consumption" | "amount")[]
  ).map(id => ({ value: id, label: getLocalizedText(METHOD_KEYS[id]) }));

  const assignedAmount = units.reduce(
    (s, u) => s + (amountByUnit[u.id] ?? 0),
    0,
  );
  const remainder = totalAmount - assignedAmount;
  const remainderOk = Math.abs(remainder) < 0.005;

  return (
    <Stack vertical spacing="loose">
      <MethodTopRow>
        <div>
          <Select
            id="dist-method"
            label={getLocalizedText("costs.modal.step.distribution_method")}
            value={distributionMethod}
            options={methodOptions}
            onChange={(opt: any) =>
              opt?.value && setDistributionMethod(opt.value)
            }
          />
        </div>

        {distributionMethod === "key" ? keyPicker : null}

        {distributionMethod === "consumption" ? (
          <div>
            <Select
              id="consumption-unit"
              label={getLocalizedText("costs.modal.unit")}
              value={consumptionUnit}
              options={CONSUMPTION_UNITS.map(u => ({
                value: u.id,
                label: u.label,
              }))}
              onChange={(opt: any) =>
                opt?.value && setConsumptionUnit(opt.value)
              }
            />
          </div>
        ) : null}
      </MethodTopRow>

      {distributionMethod === "key" ? keyActions : null}

      {distributionMethod === "consumption" ? (
        <Stack vertical spacing="tight">
          <UnitList>
            {units.flatMap(u => {
              const suffix =
                CONSUMPTION_UNITS.find(x => x.id === consumptionUnit)?.label ??
                "";
              const occupants = readingOccupantsByUnit[u.id] ?? [];
              // One reading per occupant (Y15); a unit without any in the
              // period keeps one reading for the unit.
              if (occupants.length === 0) {
                return [
                  <UnitCard key={u.id}>
                    <span className="name">{u.label}</span>
                    <div className="field">
                      <LocaleNumberField
                        name={`consumption-${u.id}`}
                        suffix={suffix}
                        value={consumptionByUnit[u.id]}
                        onChange={value =>
                          setConsumptionByUnit({
                            ...consumptionByUnit,
                            [u.id]: value ?? 0,
                          })
                        }
                      />
                    </div>
                  </UnitCard>,
                ];
              }
              return occupants.map(row => (
                <UnitCard key={`${u.id}-${row.key}`}>
                  <span className="name">
                    {u.label}
                    <div>
                      <TextStyle variation="subdued" size="small">
                        {`${row.label} · ${fmtNl(row.from)} → ${fmtNl(row.to)}`}
                      </TextStyle>
                    </div>
                  </span>
                  <div className="field">
                    <LocaleNumberField
                      name={`consumption-${u.id}-${row.key}`}
                      suffix={suffix}
                      value={consumptionByUnit[row.key]}
                      onChange={value =>
                        setConsumptionByUnit({
                          ...consumptionByUnit,
                          [row.key]: value ?? 0,
                        })
                      }
                    />
                  </div>
                </UnitCard>
              ));
            })}
          </UnitList>
          <TextStyle variation="subdued" size="small">
            {getLocalizedText("costs.modal.consumption_per_occupant")}
          </TextStyle>
        </Stack>
      ) : null}

      {distributionMethod === "amount" ? (
        <Stack vertical spacing="tight">
          <UnitList>
            {units.map(u => (
              <UnitCard key={u.id}>
                <span className="name">{u.label}</span>
                <div className="field">
                  <LocaleNumberField
                    name={`amount-${u.id}`}
                    suffix="€"
                    isMoney
                    maxDecimals={MONEY_DECIMALS}
                    negativeMessage={getLocalizedText(
                      "costs.input.negative_amount",
                    )}
                    value={amountByUnit[u.id]}
                    onChange={value =>
                      setAmountByUnit({
                        ...amountByUnit,
                        [u.id]: value ?? 0,
                      })
                    }
                  />
                </div>
              </UnitCard>
            ))}
          </UnitList>
          <RemainderNotice $ok={remainderOk}>
            {remainderOk
              ? getLocalizedText("costs.modal.remainder_ok", {
                  assigned: fmtEur(assignedAmount),
                  total: fmtEur(totalAmount),
                })
              : getLocalizedText("costs.modal.remainder_partial", {
                  total: fmtEur(totalAmount),
                  assigned: fmtEur(assignedAmount),
                  remainder: fmtEur(Math.max(0, remainder)),
                })}
          </RemainderNotice>
        </Stack>
      ) : null}
    </Stack>
  );
};

export const InvoiceModal: React.FC<InvoiceModalProps> = ({
  properties,
  fixedPropertyId,
  initialInvoice,
  departureShares,
  existingInvoices,
  onClose,
  onSaveMany,
  onUpdate,
}) => {
  const isEdit = !!initialInvoice;
  const lockedPropertyId =
    initialInvoice?.unitId ?? initialInvoice?.groupId ?? fixedPropertyId;

  const [stepIdx, setStepIdx] = useState(0);

  // Step 1 — invoice info
  const [date, setDate] = useState(initialInvoice?.date ?? todayIsoDay());
  const [category, setCategory] = useState<Category | "">(
    initialInvoice?.category ?? "",
  );
  const [categoryOther, setCategoryOther] = useState(
    initialInvoice?.categoryOther ?? "",
  );
  const [amount, setAmount] = useState(initialInvoice?.amountExclVat ?? 0);
  const [vatPct, setVatPct] = useState<VatValue>(initialInvoice?.vatPct ?? 21);
  const [supplier, setSupplier] = useState(initialInvoice?.supplier ?? "");
  const [description, setDescription] = useState(
    initialInvoice?.description ?? "",
  );
  // Deliberately empty for a new cost. Defaulting to the current calendar year
  // silently produced a plausible-looking but wrong period whenever the user
  // skipped the field — and the period drives the whole day-proration. Empty
  // forces an explicit error instead. The presets below stay one click away.
  const [periodFrom, setPeriodFrom] = useState(
    initialInvoice?.periodFrom ?? "",
  );
  const [periodTo, setPeriodTo] = useState(initialInvoice?.periodTo ?? "");

  // Step 2 — assignment
  const [selectedIds, setSelectedIds] = useState<string[]>(
    lockedPropertyId ? [lockedPropertyId] : [],
  );
  const [equalSplit, setEqualSplit] = useState(true);
  const [manualAmounts, setManualAmounts] = useState<Record<string, number>>(
    {},
  );

  // Step 3 — ten laste & settlementMethod
  // An ownership cost is the owner's, also when an older record says otherwise.
  const initialIsOwnerOnly =
    !!initialInvoice && isOwnerOnlyCategory(initialInvoice.category);
  const [chargeTarget, setChargeTarget] = useState<ChargeTarget>(() => {
    if (!initialInvoice) return "tenant";
    if (initialIsOwnerOnly) return "owner";
    return chargeTargetFromTarget(initialInvoice.target);
  });
  const [settlementMethod, setSettlementMethod] =
    useState<SettlementMethod | null>(
      initialInvoice && !initialIsOwnerOnly
        ? settlementMethodFromInvoice(initialInvoice)
        : null,
    );
  const [tenantShare, setTenantShare] = useState<number>(
    initialInvoice?.tenantSharePct ?? 100,
  );
  // False while a "Gedeeld" cost has no tenant share filled in yet. Categories
  // whose standard tenant share is 0% (Beheer, verzekering, taksen) get no
  // pre-filled value: shared at 0% would just be an owner cost, so the broker
  // must enter the share themselves (Lewis, 2026-10-05).
  const [tenantShareFilled, setTenantShareFilled] = useState(true);
  // Whether "Ten laste voor de" has a choice. A new cost in a category whose
  // standard tenant share is 0% (Beheer, verzekering, taksen, grote
  // herstellingen) gets no preselected "Huurder": one click on Volgende would
  // otherwise bill an owner cost to the tenant in full. Once the user picks a
  // target themselves, a later category change leaves it alone.
  const [chargeTargetChosen, setChargeTargetChosen] = useState(true);
  const chargeTargetTouched = useRef(!!initialInvoice);
  // Inline-validation flag: stays false until the user clicks "Volgende" on a
  // step that has missing/invalid required fields. Then we surface inline
  // errors on those fields (Rentio convention) instead of disabling the button.
  // Reset when the user actually moves to a new step.
  const [attemptedAdvance, setAttemptedAdvance] = useState(false);

  // Non-blocking duplicate check: same supplier + same amount + exact same
  // period as an already-registered cost. Warns; never prevents saving
  // (recurring identical invoices are legitimate, e.g. two equal advances).
  const duplicateOf = useMemo(() => {
    if (isEdit || !supplier.trim() || amount <= 0) return undefined;
    return existingInvoices?.find(
      i =>
        i.supplier.trim().toLowerCase() === supplier.trim().toLowerCase() &&
        Math.abs(i.amountExclVat - amount) < 0.005 &&
        i.periodFrom === periodFrom &&
        i.periodTo === periodTo,
    );
  }, [isEdit, existingInvoices, supplier, amount, periodFrom, periodTo]);

  // Unified step counter: the embedded PaymentForm uses its own redux form id;
  // we generate it here so we can subscribe to its current step from outside,
  // and merge that with the cost-wizard's own step indices into a single
  // running "Stap X / Y" displayed in StepTitle.
  const [paymentFormId, setPaymentFormId] = useState(
    () => `cost-payment-${generateFormId()}`,
  );
  const [paymentSchemaCount, setPaymentSchemaCount] = useState<number>(0);
  // The payment orders this popup created, per tenant share (keyed by the
  // share's contract), so the cost links every split to its own tenant's order
  // and request — never by position, which linked a tenant to another
  // tenant's order once the loop restarted. The ref is read by the save right
  // after a submit, before the state update renders; the state drives what
  // the popup shows.
  const reduxStore = useStore();
  const createdOrdersRef = useRef<ICreatedOrderLinks>(NO_CREATED_ORDERS);
  const [createdOrders, setCreatedOrders] =
    useState<ICreatedOrderLinks>(NO_CREATED_ORDERS);
  const createdOrderCount = Object.keys(createdOrders.orderByContract).length;
  const hasCreatedOrders = createdOrderCount > 0;
  // How many of those orders the stored cost holds: the cost is stored after
  // every order (see persistBilled).
  const [storedOrderCount, setStoredOrderCount] = useState(0);
  const hasUnstoredOrders = createdOrderCount > storedOrderCount;
  // Orders exist that no stored cost holds yet (their save is running or
  // failed): leaving the page now (reload, back, another page) would leave
  // them without a cost, so the broker is asked first. Closing the popup
  // saves the cost with them instead (see handleRequestClose); the guard
  // goes once the cost holds them, or when the popup closes.
  const navigationContext = React.useContext(UNSAFE_NavigationContext);
  const routerNavigator = navigationContext?.navigator;
  React.useEffect(() => {
    if (!hasUnstoredOrders || !routerNavigator) return undefined;
    const { navigation } = window as Window & {
      navigation?: ITraversalNavigation;
    };
    return installLeaveGuard({
      target: window,
      location: window.location,
      navigator: routerNavigator,
      navigation,
      shouldAsk: () => true,
      askToLeave: leave =>
        confirmLeave({
          title: getLocalizedText("costs.modal.leave_with_orders.title"),
          info: getLocalizedText("costs.modal.leave_with_orders.info"),
          leave,
        }),
    });
  }, [hasUnstoredOrders, routerNavigator]);
  // Ids already in `createPaymentOrders.ids` before a submit: only the ones
  // after it are this submit's orders.
  const knownOrderIdsRef = useRef<number[]>([]);
  const readCreatedOrderIds = (): number[] =>
    (reduxStore.getState() as any)?.PAYMENT_ORDERS_V2?.createPaymentOrders
      ?.ids ?? [];
  // Link the order(s) a submit just created to the shares it billed.
  const captureCreatedOrders = (shares: PayShare[]) => {
    const detail =
      (reduxStore.getState() as any)?.PAYMENT_ORDERS_V2?.detail ?? {};
    const createdOrderIds = readCreatedOrderIds().filter(
      id => !knownOrderIdsRef.current.includes(id),
    );
    knownOrderIdsRef.current = [
      ...knownOrderIdsRef.current,
      ...createdOrderIds,
    ];
    const links = linkCreatedOrders({
      shares,
      createdOrderIds,
      ordersById: detail,
    });
    const next: ICreatedOrderLinks = {
      orderByContract: {
        ...createdOrdersRef.current.orderByContract,
        ...links.orderByContract,
      },
      requestByContract: {
        ...createdOrdersRef.current.requestByContract,
        ...links.requestByContract,
      },
      payerByContract: {
        ...createdOrdersRef.current.payerByContract,
        ...links.payerByContract,
      },
    };
    createdOrdersRef.current = next;
    setCreatedOrders(next);
  };
  const isShareBilled = (share: PayShare) =>
    createdOrders.orderByContract[share.contractId] != null;
  // We track the active inner step locally via onStepChange — the redux
  // currentStepIndex only updates when a form field is touched, so it never
  // catches the jump to the summary step (which has no inputs).
  const [innerStepIndex, setInnerStepIndex] = useState<number>(0);
  // Position among the inner form's visible steps: 0 = its first one, where
  // "Vorige" leaves the payment step.
  const [innerVisibleIndex, setInnerVisibleIndex] = useState<number>(0);
  // Imperative handle on the embedded MultiStepForm — used to drive its
  // Volgende/Vorige from this modal's single footer, so the embedded payment
  // flow reads as one continuous wizard instead of two stacked ones.
  const paymentFormRef = useRef<any>(null);
  // Loading state of the payment-order create call (lights up the modal's
  // "Verzenden" button while the request is in flight).
  const isSubmittingPayment = useSelector(
    isPerformingSubmitActionSelector(undefined, true),
  );
  // Saving the cost runs once: a double click on "Opslaan" created it twice,
  // and the next settlement then billed the tenant twice. The ref stops a
  // click that lands before the disabled button renders. Only a failure
  // releases it: a successful save closes the modal.
  const isSavingRef = useRef(false);
  const [isSaving, setIsSaving] = useState(false);
  const runSaveOnce = async (save: () => Promise<void>) => {
    if (isSavingRef.current) return;
    isSavingRef.current = true;
    setIsSaving(true);
    try {
      await save();
    } catch (error) {
      isSavingRef.current = false;
      setIsSaving(false);
      throw error;
    }
  };
  // Multiple tenants: fill the payment details once for all ("bulk") or step
  // through the payment flow once per tenant. Both create one separate payment
  // order + group + open payment per tenant.
  const [paymentMode, setPaymentMode] = useState<"bulk" | "perTenant">("bulk");
  // The VAT of the recharge to a VAT-taxable lease, chosen by the broker
  // (see leaseVat.utils). Undefined until chosen: Rentio never picks it.
  const [outgoingVat, setOutgoingVat] = useState<TOutgoingVat>();
  // The payer the broker chose for a lease with several tenants or a parent,
  // by contract id (see payerOfLease).
  const [payerChoiceByContract, setPayerChoiceByContract] = useState<
    Record<string, number>
  >({});
  const [payIndex, setPayIndex] = useState(0);
  // "Alles in één keer per eigenaar": the form showing, among ownerPayRuns.
  const [payRunIndex, setPayRunIndex] = useState(0);
  // For a building cost: the apportionment key chosen for this cost (defaults to
  // the system "Gelijke verdeling" key, resolved below once keys load).
  const [selectedKeyId, setSelectedKeyId] = useState<string | undefined>(
    undefined,
  );
  // Distribution method for a building cost — one of three, keeping the
  // apportionment decision at cost-creation time (matches the "verdeelsleutel
  // bij kost"-model).
  //   key         = weighted apportionment via a saved sleutel (default)
  //   consumption = individual meter reading per pand (kWh, m³, ...)
  //   amount      = manual EUR assignment per pand, with a running-remainder
  //                 validator so the sum matches the invoice total
  const [distributionMethod, setDistributionMethod] = useState<
    "key" | "consumption" | "amount"
  >("key");
  const [consumptionUnit, setConsumptionUnit] = useState<"kwh" | "m3">("m3");
  const [consumptionByUnit, setConsumptionByUnit] = useState<
    Record<string, number>
  >({});
  const [amountByUnit, setAmountByUnit] = useState<Record<string, number>>({});
  // A cost is "already paid" when that option is chosen in the settlement-method list.
  const markPaid = settlementMethod === "paid";
  // Uploaded invoice document (PDF/UBL). We store the document id; the name is
  // only kept for display right after upload. On edit we only have the id.
  const dispatch = useDispatch();
  const [documentId, setDocumentId] = useState<string | undefined>(
    initialInvoice?.documentUrl,
  );
  const [documentName, setDocumentName] = useState<string | undefined>();
  const [uploadingDoc, setUploadingDoc] = useState(false);

  const incl = useMemo(
    () =>
      roundCents(
        amount +
          vatOfAmount({ amountExclVat: amount, vatPct: vatPercent(vatPct) }),
      ),
    [amount, vatPct],
  );

  // "Gelijk verdelen" in whole cents: the remainder cents go to the first
  // panden, so the parts add up to the invoice (€ 100 over 3 panden is
  // 33,34 + 33,33 + 33,33, not 3 × 33,33). Each pand is saved as a cost of
  // its own with the VAT of its own amount, so where that split would pass
  // on a cent more or less VAT than the invoice, a few cents move between
  // the panden until it does not (€ 1.000,03 at 21% over 3 panden is
  // 333,36 + 333,33 + 333,34, see splitInvoiceEqually).
  const plainEqualParts = splitEqually({ amount, parts: selectedIds.length });
  const equalParts = useMemo(
    () =>
      splitInvoiceEqually({
        amount,
        parts: selectedIds.length,
        vatPct: vatPercent(vatPct),
      }),
    [amount, selectedIds.length, vatPct],
  );
  const isEqualSplitShiftedForVat = equalParts.some(
    (part, index) => toCents(part) !== toCents(plainEqualParts[index]),
  );
  const equalById: Record<string, number> = Object.fromEntries(
    selectedIds.map((id, i) => [id, equalParts[i]]),
  );
  const amountFor = (id: string) =>
    equalSplit ? equalById[id] ?? 0 : manualAmounts[id] ?? 0;
  const sumManualCents = sumInCents(selectedIds.map(amountFor));
  const sumManual = fromCents(sumManualCents);
  // A manual split must add up to the invoice to the cent: € 600 + € 634,56
  // on an invoice of € 1.234,57 is one cent short.
  const isSplitSumOff = !equalSplit && sumManualCents !== toCents(amount);
  const btwOf = (n: number) =>
    vatOfAmount({ amountExclVat: n, vatPct: vatPercent(vatPct) });
  // Over several panden: the VAT the panden pass on together, and the
  // invoice's, which can differ by a rounding cent (see splitInvoiceVat).
  const splitVatTotals = splitInvoiceVat({
    invoiceAmount: amount,
    parts: selectedIds.map(amountFor),
    vatPct: vatPercent(vatPct),
  });

  // The property we create the payment(s) for, and its real rental contracts.
  const payPropertyId = selectedIds[0];
  const rentalContracts = usePropertyRentalContracts(
    payPropertyId ? +payPropertyId : undefined,
  );
  // Full property detail (with members) — used to share the uploaded invoice
  // document with the owners.
  const { detail: payProperty } = propertyHooks.useDetail({
    id: payPropertyId ? +payPropertyId : undefined,
    shouldRefetch: !!payPropertyId,
  });
  // Real contracts of EVERY selected property → drive the day-based split and
  // the occupancy check. No demo fallback: a property without contracts simply
  // has no tenant occupancy (its share falls on the owner).
  const { rentals: selectedContracts, isLoaded: areSelectedContractsLoaded } =
    useGroupRentalContractsState(
      selectedIds.map(Number).filter(n => !Number.isNaN(n)),
    );
  const contractsForProperty = (id: string) =>
    selectedContracts.filter(r => r.ref.unitId === id).map(r => r.ref);

  const typeLabel = (p?: AssignProperty) =>
    p?.type === "building"
      ? getLocalizedText("costs.scope.group")
      : getLocalizedText("costs.field.property");
  const labelFor = (p: AssignProperty) => p.address ?? p.code;

  // ---- Building cost: split across its units via an apportionment key.
  // For a building, the cost lands on a single group property; the real units
  // and their tenants drive the per-apartment/per-tenant distribution + payments.
  const targetProperty = properties.find(p => p.id === payPropertyId);
  const isBuildingCost = targetProperty?.type === "building";
  const buildingId = isBuildingCost ? payPropertyId : undefined;

  const { units: groupUnits, isFetching: isFetchingBuildingUnits } =
    useGroupUnits(buildingId);
  // The units that were part of the group during the cost's period: one
  // archived since keeps its share (vacancy for its owner when nobody rented
  // it), one archived before plays no part.
  const buildingUnits = unitsExistingSince({
    units: groupUnits,
    from: periodFrom,
  });
  const buildingUnitIds = buildingUnits.map(u => u.id);
  // A unit by its full address with its box spelled out, "Groepslaan 20 bus
  // 3, 9000 Gent"; a building's units list it when the office's properties
  // do not.
  const unitAddressOf = (id: string): string => {
    const property = properties.find(p => p.id === id);
    if (property) {
      return property.addressParts
        ? unitAddressLabel(property)
        : labelFor(property);
    }
    return groupUnits.find(unit => String(unit.id) === id)?.label ?? id;
  };
  const { rentals: buildingContracts, isLoaded: areBuildingContractsLoaded } =
    useGroupRentalContractsState(buildingUnitIds);
  const { items: keys, create: createKey } = useKeys(buildingId ?? "");
  // "Nieuwe verdeelsleutel" from inside the wizard.
  const [creatingKey, setCreatingKey] = useState(false);

  // The chosen key. Nothing is pre-selected: "Gelijke verdeling" is a real
  // choice in the list (useKeys synthesizes it for a group that has none yet),
  // not a default that slips through unnoticed — the split it produces is a
  // decision the user has to make. `equalKey` only survives as the render-time
  // fallback for the preview; the method step cannot be passed without a pick.
  // Weights are keyed by real unit property id, so they resolve directly —
  // never by position.
  const equalKey = keys.find(k => k.isSystem && k.isEqual) ?? keys[0];
  const activeKey = keys.find(k => k.id === selectedKeyId) ?? equalKey;
  // Effective per-unit weight = the number the engine turns into a EUR slice
  // via `slice = amount × weight / totalWeight`. For "key" we derive weights
  // from the chosen sleutel. For "consumption" we pass the raw meter reading
  // (proportional distribution). For "amount" we pass the manual EUR — sum
  // must equal the invoice amount for the slices to be exact, hence the
  // running-remainder validator in the UI.
  const unitWeights: Record<string, number> = {};
  if (distributionMethod === "key") {
    buildingUnits.forEach(u => {
      unitWeights[String(u.id)] = activeKey?.isEqual
        ? 1
        : activeKey?.weights[String(u.id)] ?? 0;
    });
  } else if (distributionMethod === "consumption") {
    // Filled in below, from the readings per occupant (Y15).
  } else {
    buildingUnits.forEach(u => {
      unitWeights[String(u.id)] = amountByUnit[String(u.id)] ?? 0;
    });
  }

  const contractsByUnit: Record<string, ContractRef[]> = {};
  const rentalByContractId: Record<string, (typeof buildingContracts)[number]> =
    {};
  buildingContracts.forEach(rc => {
    (contractsByUnit[rc.ref.unitId] ??= []).push(rc.ref);
    rentalByContractId[rc.ref.id] = rc;
  });
  // A reading per occupant of each unit (Y15): each tenant of the cost's
  // period and the unit's vacant days, as the settlement's editor asks it.
  const readingOccupantsByUnit: Record<string, IReadingOccupant[]> =
    Object.fromEntries(
      buildingUnits.map(u => [
        String(u.id),
        readingOccupantsOf({
          unitId: String(u.id),
          contracts: contractsByUnit[String(u.id)] ?? [],
          period: { from: periodFrom, to: periodTo },
          vacancyLabel: getLocalizedText("settlement.summary.vacancy"),
        }),
      ]),
    );
  if (distributionMethod === "consumption") {
    buildingUnits.forEach(u => {
      unitWeights[String(u.id)] = unitReadingOf({
        unitId: String(u.id),
        occupants: readingOccupantsByUnit[String(u.id)] ?? [],
        values: consumptionByUnit,
      });
    });
  }

  const breakdownByKey = isBuildingCost
    ? buildingBreakdown({
        amount: payPropertyId ? amountFor(payPropertyId) : 0,
        tenantSharePct: chargeTarget === "shared" ? tenantShare : 100,
        units: buildingUnits.map(u => ({ id: String(u.id), label: u.label })),
        contractsByUnit,
        weights: unitWeights,
        period: { from: periodFrom, to: periodTo },
      })
    : undefined;
  // With readings, each unit's part goes to its occupants by their own
  // readings, never by their days (Y15).
  const breakdownByReadings =
    breakdownByKey && distributionMethod === "consumption"
      ? {
          ...breakdownByKey,
          units: breakdownByKey.units.map(unit => ({
            ...unit,
            proration: prorationByReadings({
              proration: unit.proration,
              occupants: readingOccupantsByUnit[unit.unitId] ?? [],
              values: consumptionByUnit,
            }),
          })),
        }
      : breakdownByKey;
  const buildingResult = breakdownByReadings ?? {
    units: [],
    periodDays: 0,
    total: 0,
    coverage: { uncoveredUnitIds: [], fellBackToEqual: false },
  };

  // The leases a cost billed right away does not bill, because they price
  // its kind as a forfait (decision 20): their share stays with the owner.
  const fixedFeeLeases = fixedFeeLeaseIds({
    leases: isBuildingCost
      ? buildingContracts.map(rc => rc.ref)
      : selectedContracts.map(rc => rc.ref),
    isBuildingCost,
  });

  const categoryOptions = sortedCategoryOptions();
  const vatOptions = VAT_OPTIONS.map(v => ({
    value: String(v),
    label: vatLabel(v),
  }));
  // ---- validation per step ----
  const today = todayIsoDay();
  const dateError = (() => {
    if (date === "")
      return getLocalizedText("costs.modal.invoice_date_required");
    if (date > today)
      return getLocalizedText("costs.modal.invoice_date_future");
    return undefined;
  })();
  // The period is required: it decides how the cost is spread over the
  // contracts, so an empty one cannot be waved through.
  const periodFromError = !periodFrom
    ? getLocalizedText("costs.modal.period_required")
    : undefined;
  const periodError = (() => {
    if (!periodTo) return getLocalizedText("costs.modal.period_required");
    if (periodFrom && periodTo < periodFrom)
      return getLocalizedText("costs.modal.period_end_before_start");
    if (periodFrom && isCostPeriodTooLong({ from: periodFrom, to: periodTo }))
      return getLocalizedText("costs.modal.period_too_long", {
        years: String(MAX_COST_PERIOD_YEARS),
      });
    return undefined;
  })();

  // A cost whose payment was already requested: re-running the flow would
  // create duplicate betaalopdrachten, and the money is on its way to the
  // tenant. Only the invoice details (date, supplier, description, document)
  // can still be corrected; amount, period, category and distribution stay.
  // The splits' links say whether a payment is out; the cost-level date only
  // for a cost from before splits (it outlives a withdrawn payment).
  const initialSplits = initialInvoice?.paymentSplits ?? [];
  const hasSentPayment =
    (!!initialInvoice?.paymentRequestedAt && initialSplits.length === 0) ||
    initialSplits.some(
      s => !!s.paymentOrderId || !!s.requestedAt || s.paymentRequestId != null,
    );
  const isPaymentLocked = isEdit && hasSentPayment;
  // A departure settled part of the cost: the rest follows in the settlement
  // of the unit or the group, so the cost cannot be billed right away or
  // marked paid any more (the API refuses that too).
  const heldDepartureShares = isEdit ? departureShares ?? [] : [];
  const isHeldByDeparture = heldDepartureShares.length > 0;

  const invoiceDetailsValid =
    supplier.trim().length > 0 &&
    description.trim().length > 0 &&
    !dateError &&
    (category !== "Other" || categoryOther.trim().length > 0);
  const step1Valid =
    invoiceDetailsValid &&
    (isPaymentLocked ||
      (amount > 0 && !periodFromError && !periodError && category !== ""));
  // Every pand of a manual split carries a real part of the invoice: a pand
  // at € 0 (or a typo the field could not read) is not a split.
  const isManualAmountMissing = (id: string) =>
    !equalSplit && !((manualAmounts[id] ?? 0) > 0);
  const step2Valid =
    selectedIds.length > 0 &&
    !selectedIds.some(isManualAmountMissing) &&
    !isSplitSumOff;
  const needsReg =
    chargeTargetChosen &&
    (chargeTarget === "tenant" || chargeTarget === "shared");
  const tenantShareMissing = chargeTarget === "shared" && !tenantShareFilled;
  const step3Valid =
    chargeTargetChosen &&
    (!needsReg || settlementMethod != null) &&
    !tenantShareMissing;

  // Per-field error messages — only surfaced after the user clicked "Volgende"
  // on a step that has missing/invalid required fields. Otherwise pristine.
  const errIf = (cond: boolean, msg: string) =>
    attemptedAdvance && cond ? msg : undefined;
  const fieldErrors = {
    date: attemptedAdvance ? dateError : undefined,
    periodFrom: attemptedAdvance ? periodFromError : undefined,
    periodTo: attemptedAdvance ? periodError : undefined,
    category: errIf(
      category === "",
      getLocalizedText("costs.modal.category_required"),
    ),
    categoryOther: errIf(
      category === "Other" && categoryOther.trim().length === 0,
      getLocalizedText("costs.modal.category_other_required"),
    ),
    amount: errIf(
      !(amount > 0),
      getLocalizedText("costs.modal.amount_required"),
    ),
    supplier: errIf(
      supplier.trim().length === 0,
      getLocalizedText("costs.modal.supplier_required"),
    ),
    description: errIf(
      description.trim().length === 0,
      getLocalizedText("costs.modal.description_required"),
    ),
    properties: errIf(
      selectedIds.length === 0,
      getLocalizedText("costs.modal.properties_required"),
    ),
    splitSum:
      attemptedAdvance && isSplitSumOff
        ? getLocalizedText("costs.modal.split_sum_mismatch", {
            amount: fmtEur(amount),
          })
        : undefined,
    tenantShare: errIf(
      tenantShareMissing,
      getLocalizedText("costs.modal.tenant_share_required"),
    ),
    settlementMethod: errIf(
      needsReg && settlementMethod == null,
      getLocalizedText("costs.modal.settlement_method_required"),
    ),
    chargeTarget: errIf(
      !chargeTargetChosen,
      getLocalizedText("costs.modal.charged_to_required"),
    ),
  };
  const manualAmountError = (id: string) =>
    errIf(
      isManualAmountMissing(id),
      getLocalizedText("costs.modal.amount_required"),
    );

  // Picking a category proposes who bears the cost (proposedChargeFor) until
  // the user chose that themselves. An ownership cost is locked to the owner,
  // whatever was chosen before.
  const isOwnerOnlyCost = category !== "" && isOwnerOnlyCategory(category);
  const handleCategoryChange = (nextCategory: Category) => {
    setCategory(nextCategory);
    const proposed = proposedChargeFor(nextCategory);
    if (proposed.target === "owner") {
      setChargeTarget("owner");
      setChargeTargetChosen(true);
      setSettlementMethod(null);
      return;
    }
    if (chargeTargetTouched.current) {
      // A "Gedeeld" cost follows the new category's standard share (none for
      // a 0% category), like switching to Gedeeld. A stored share stays.
      if (chargeTarget === "shared" && initialInvoice?.target !== "shared") {
        const standard = CATEGORY_META[nextCategory]?.defaultTenantSharePct;
        setTenantShare(standard ?? MAX_PERCENTAGE);
        setTenantShareFilled((standard ?? MAX_PERCENTAGE) > 0);
      }
      return;
    }
    setChargeTargetChosen(proposed.target !== undefined);
    if (proposed.target === "shared") {
      setChargeTarget("shared");
      setTenantShare(proposed.tenantSharePct);
      setTenantShareFilled(true);
      return;
    }
    if (proposed.target === "tenant") setChargeTarget("tenant");
  };

  // When the cost lands (partly) on tenants, a "Verdeling" step shows how the
  // cost splits across the tenants that occupied the property in the period. And when
  // an immediate payment is requested, the real payment flow follows as a step.
  // Editing a cost may also send a payment, but only when it doesn't already
  // have one — re-running the flow on an already-sent cost would create
  // duplicate betaalopdrachten. So a "settlement"/"reeds betaald" cost (no
  // payment yet) can be switched to "Onmiddellijke betaling vragen" via Wijzigen.
  const wantsPayment =
    needsReg && settlementMethod === "direct" && !hasSentPayment;
  // The tenants of a cost paid right away each get a payment request, which
  // bills the VAT on their own share; the "Verdeling" shows that VAT (see
  // costVat.utils).
  const costBilling: TCostBilling =
    settlementMethod === "direct" ? "immediate" : "settlement";
  // Is this cost settled NOW instead of in the annual afrekening? Either a
  // payment is requested immediately, or it is marked as already paid. Both
  // divide the money over the panden right away, so both ask for the
  // verdeelsleutel. A cost bound for the afrekening does not: that verdeling
  // is decided there, with the sleutel chosen there, and the cost is stored as
  // one lump-sum common cost. Unit costs are unaffected either way — their
  // tenant split is day-based, not key-based.
  const settlesNow = wantsPayment || markPaid;
  const showDistribution = needsReg && (!isBuildingCost || settlesNow);
  // Note: we deliberately don't show a "Stap X / Y" counter — Rentio's other
  // wizards don't either. We still subscribe to the inner step index below so
  // we can flip the modal's primary button label between "Volgende" and
  // "Verzenden" on the payment-form's summary step.
  // (`steps`/`idx`/`stepKey` are computed after `payShares` further down,
  //  because the "paymentOrders" step only exists when there's an actual
  //  bulk-vs-perTenant choice to make.)

  // ---- save ----
  // Full vacancy in the cost's period → there is no tenant to ever charge, so
  // the cost effectively belongs to the owner. Qualify it as such at save time;
  // the lists then show "—" for the tenant payment status instead of a
  // forever-pending "Nog af te rekenen".
  const hasTenantOccupancy = (id: string): boolean => {
    // A tenant on a forfait for the cost's kind is never billed it
    // (decision 20), so their days do not count as occupancy here.
    if (isBuildingCost && id === buildingId) {
      return buildingResult.units.some(u =>
        u.proration.shares.some(
          sh => sh.amount > 0.005 && !fixedFeeLeases.has(sh.contractId),
        ),
      );
    }
    return contractsForProperty(id).some(
      c =>
        c.endDate >= periodFrom &&
        c.startDate <= periodTo &&
        !fixedFeeLeases.has(c.id),
    );
  };

  // No tenant occupancy in ANY selected property → the "onmiddellijke
  // betaling" option is meaningless (nobody to invite) and gets grayed out.
  // "No tenants in the period" can only be concluded once the leases have
  // actually arrived: the chosen unit's, or the group's units AND their
  // leases (see isCostOccupancyKnown). While a fetch is in flight the list is
  // empty, which reads as vacancy — and would silently store a tenant cost as
  // an owner cost, stripping its verdeelsleutel.
  const occupancyKnown = isCostOccupancyKnown({
    isBuildingCost,
    areLeasesLoaded: areSelectedContractsLoaded,
    isFetchingBuildingUnits,
    buildingUnitCount: buildingUnits.length,
    areBuildingLeasesLoaded: areBuildingContractsLoaded,
  });

  const noTenantsInPeriod =
    occupancyKnown &&
    selectedIds.length > 0 &&
    selectedIds.every(id => !hasTenantOccupancy(id));
  // Why "request immediate payment" cannot be chosen: a departure settled
  // part of the cost, or full vacancy leaves no tenant to request it from.
  // Said under the payment-method options (a disabled option takes no
  // pointer events, so a tooltip on it never opened), naming the vacant
  // unit by its full address, or the building, and the cost's period.
  const vacancyReason = (): string => {
    const addressOf = unitAddressOf;
    const period = { from: fmtNl(periodFrom), to: fmtNl(periodTo) };
    if (isBuildingCost) {
      return getLocalizedText("costs.modal.method.direct_vacant_building", {
        building: addressOf(payPropertyId),
        ...period,
      });
    }
    if (selectedIds.length === 1) {
      return getLocalizedText("costs.modal.method.direct_vacant_unit", {
        unit: addressOf(selectedIds[0]),
        ...period,
      });
    }
    return getLocalizedText("costs.modal.method.direct_vacant_units", period);
  };
  // A cost of the building, or one spread over several units, goes through
  // the settlement (Lewis, 2026-10-21): billed at once it never reaches one,
  // so the provisions the tenants pay for it would not be offset. A cost
  // whose payment went out already keeps it.
  const spansSeveralUnits = isBuildingCost || selectedIds.length > 1;
  const directDisabledReason = (() => {
    if (isHeldByDeparture) {
      return getLocalizedText("costs.modal.method.departure_disabled");
    }
    if (spansSeveralUnits && !hasSentPayment) {
      return getLocalizedText("costs.modal.method.direct_several_units");
    }
    if (noTenantsInPeriod) return vacancyReason();
    return undefined;
  })();
  // A choice that became unavailable (more units picked after "direct") is
  // undone, so the broker chooses again.
  React.useEffect(() => {
    if (
      directDisabledReason &&
      settlementMethod === "direct" &&
      !hasSentPayment
    ) {
      setSettlementMethod(null);
    }
  }, [directDisabledReason, settlementMethod, hasSentPayment]);

  const buildTarget = (
    id: string,
  ): {
    target: InvoiceTarget;
    tenantSharePct?: number;
  } => {
    if (chargeTarget === "owner") return { target: "owner" };
    if (occupancyKnown && !hasTenantOccupancy(id)) return { target: "owner" };
    if (chargeTarget === "shared")
      return { target: "shared", tenantSharePct: tenantShare };
    // tenant: only "direct" requests an immediate payment. "settlement" and
    // "paid" are both settlement-bound — a "paid" cost just also carries a
    // paidAt, so un-marking it as paid returns it to the annual settlement
    // ("Nog af te rekenen") rather than stranding it as an order-less "direct".
    return {
      target: settlementMethod === "direct" ? "direct" : "settlement",
    };
  };

  // `sent` marks a direct cost whose payment order was actually created + sent.
  const basePayload = (id: string, sent = false): Omit<Invoice, "id"> => {
    const { target, tenantSharePct } = buildTarget(id);
    // Splits land on the cost belonging to the property the payment was
    // actually created on. For building costs that single cost on the building
    // id carries shares across all its units.
    const splits: PaymentSplit[] | undefined = (() => {
      const carriesShares = id === payPropertyId && payShares.length > 0;
      // Marked as already paid: no payment orders are created, but the
      // verdeling the user just chose still has to be recorded. Without it the
      // cost has no split of its own and the detail screen falls back to
      // projecting an equal one nobody picked. No `paidAt` per split — the
      // cost-level paidAt says the invoice was settled with the supplier, not
      // that each tenant paid their share.
      if (!sent && markPaid && carriesShares) {
        return payShares.map((s, ix) => ({
          id: `split_${id}_${ix}`,
          payerId: s.payerId ?? 0,
          payerName: shareLabel(s),
          amount: s.amount,
          ...leaseOfShare(s),
        }));
      }
      if (!sent || !carriesShares) {
        return initialInvoice?.paymentSplits;
      }
      const today = todayIsoDay();
      const { orderByContract, requestByContract, payerByContract } =
        createdOrdersRef.current;
      return payShares.map((s, ix) => {
        // Each share gets the order created for it (see captureCreatedOrders).
        // A share without one — the popup was closed halfway, or its
        // submission failed — stays unlinked instead of being stamped
        // "verzonden" against another tenant's order.
        const orderId = orderByContract[s.contractId];
        const hasOrder = orderId != null;
        const requestId = hasOrder
          ? requestByContract[s.contractId]
          : undefined;
        // The payer the order bills, also when the payment form asked for
        // one: the split is named after that person, not after the lease.
        const payerId =
          s.payerId ?? (hasOrder ? payerByContract[s.contractId] : undefined);
        return {
          id: `split_${id}_${ix}`,
          payerId: payerId ?? 0,
          payerName:
            getPayerName({
              candidates: payerCandidatesOf(s.contractId),
              accountId: payerId,
            }) ?? shareLabel(s),
          amount: s.amount,
          // Its lease and unit: a tenant left unbilled is billed later on
          // them (see remainingShares), with the same part of the VAT.
          ...leaseOfShare(s),
          ...(hasOrder ? billedVatOfShare(s) : { supplierVat: s.supplierVat }),
          paymentOrderId: hasOrder ? String(orderId) : undefined,
          paymentRequestId: requestId,
          // Only mark the invitation as sent for splits that actually got
          // a paymentOrder during the wizard. Splits that were skipped or
          // failed mid-flow stay as "Nog te innen".
          requestedAt: hasOrder ? today : undefined,
        };
      });
    })();
    // The split a group cost settled right away is billed with goes on the
    // group cost, so its detail shows that split. An edit that hands the split
    // back to the settlement clears a stored one.
    const distribution =
      id === payPropertyId && target !== "owner" ? costDistribution : undefined;
    return {
      unitId: id,
      scope: "private",
      date,
      periodFrom,
      periodTo,
      category: category as Category,
      categoryOther:
        category === "Other" ? categoryOther.trim() || undefined : undefined,
      supplier: supplier.trim(),
      description: description.trim() || undefined,
      amountExclVat: amountFor(id),
      vatPct,
      target,
      tenantSharePct,
      documentUrl: documentId || undefined,
      paidAt: markPaid ? initialInvoice?.paidAt ?? todayIsoDay() : undefined,
      paymentRequestedAt: sent
        ? todayIsoDay()
        : initialInvoice?.paymentRequestedAt,
      paymentSplits: splits,
      ...(distribution || initialInvoice?.distribution ? { distribution } : {}),
    };
  };

  // Share the uploaded invoice document with the cost's stakeholders: the
  // property owners always, the occupying tenants when they (co-)pay the
  // cost. The broker uploads the document and already sees it. Best-effort:
  // a share failure must never block saving the cost itself.
  const shareDocumentWithStakeholders = async () => {
    if (!documentId) return;
    const accountIds = new Set<number>();
    getMembersWithRole(
      payProperty?.members ?? [],
      EPropertyMemberTypes.Owner,
    ).forEach(m => {
      if (m.account?.id != null) accountIds.add(m.account.id);
    });
    if (chargeTarget !== "owner") {
      const contracts = isBuildingCost ? buildingContracts : rentalContracts;
      contracts.forEach(c => {
        if (c.tenantAccountId == null) return;
        // Only tenants whose contract overlaps the cost period.
        if (c.ref.endDate >= periodFrom && c.ref.startDate <= periodTo) {
          accountIds.add(c.tenantAccountId);
        }
      });
    }
    if (accountIds.size === 0) return;
    try {
      await documentApi.addMembers({
        id: documentId,
        members: [...accountIds].map(accountId => ({
          accountId,
          roles: [EDocumentMemberTypes.Viewer],
        })),
      });
    } catch (e) {
      logError({ type: EErrorType.General, error: e as Error });
    }
  };

  // An edited cost keeps its level: basePayload builds a unit (private) cost,
  // which turned a group cost into a cost of one of its units on every save.
  const keepLevel = (payload: Omit<Invoice, "id">): Omit<Invoice, "id"> =>
    initialInvoice?.scope === "common" && payload.target !== "owner"
      ? {
          ...payload,
          scope: "common",
          unitId: initialInvoice.unitId,
          groupId: initialInvoice.groupId,
        }
      : payload;

  // The costs this popup stored, by pand id, with their id when the caller
  // returned it: a later save updates them and never creates them again (a
  // retry after a failed save created a pand's cost a second time).
  const storedCostIdsRef = useRef<Record<string, string | undefined>>({});
  const rememberStoredCost = (stored: { key: string; id?: string }) => {
    storedCostIdsRef.current = {
      ...storedCostIdsRef.current,
      [stored.key]: stored.id,
    };
  };
  // Creates every pand's cost that is not stored yet, one at a time.
  const createCostsOnce = (sent: boolean) =>
    createMissingCosts({
      entries: selectedIds.map(id => ({
        key: id,
        payload: basePayload(id, sent && id === payPropertyId),
      })),
      storedIds: storedCostIdsRef.current,
      create: async payload => (await onSaveMany([payload]))?.[0]?.id,
      onStored: rememberStoredCost,
    });

  // The invoice details of a cost whose payment was requested: only they
  // travel, the amount, period and split the payment was requested for stay
  // exactly as they are.
  const saveInvoiceDetails = async () => {
    if (!initialInvoice || !onUpdate) return;
    await shareDocumentWithStakeholders();
    await onUpdate(initialInvoice.id, {
      date,
      supplier: supplier.trim(),
      description: description.trim() || undefined,
      documentUrl: documentId || undefined,
      ...(category === "Other"
        ? { categoryOther: categoryOther.trim() || undefined }
        : {}),
    });
  };

  const saveCost = async () => {
    if (isPaymentLocked && initialInvoice && onUpdate) {
      await saveInvoiceDetails();
      onClose();
      return;
    }
    await shareDocumentWithStakeholders();
    if (isEdit && initialInvoice && onUpdate) {
      await onUpdate(
        initialInvoice.id,
        keepLevel(basePayload(selectedIds[0] ?? initialInvoice.unitId ?? "")),
      );
      onClose();
      return;
    }
    if (isBuildingCost) {
      // Store the whole building cost as ONE record instead of pre-splitting it
      // per unit. A tenant/shared cost becomes a `common` cost on the group —
      // the afrekening's verdeelsleutel step decides how the engine spreads it
      // over the units. An owner cost has no tenant distribution, so it stays a
      // plain private cost that lands entirely on the owner.
      const base = basePayload(payPropertyId);
      const groupCost: Omit<Invoice, "id"> =
        base.target === "owner"
          ? base
          : {
              ...base,
              scope: "common",
              unitId: undefined,
              groupId: payPropertyId,
            };
      await onSaveMany([groupCost]);
      onClose();
      return;
    }
    // A failed save may have stored the cost of some panden already: those
    // get what the popup holds now (it may have been corrected since), and
    // only the others are created.
    for (const id of selectedIds) {
      const storedId = storedCostIdsRef.current[id];
      // eslint-disable-next-line no-await-in-loop
      if (storedId) await updateStoredCost(storedId, basePayload(id));
    }
    await createCostsOnce(false);
    onClose();
  };
  const handleSave = () => runSaveOnce(saveCost);

  // Direct cost + "create now": move into the embedded payment step. The cost is
  // stored once its first payment order exists, and again after every later
  // one (see persistBilled). The shares are frozen for the payment step: each
  // order is linked to its share, and the split must store the amount that
  // was billed, whatever a background refetch of the contracts changes
  // meanwhile. So is the choice between one form and a form per tenant: the
  // owners arriving later swapped a running form for another one.
  const handleStartPayment = () => {
    setFrozenPayShares(payShares);
    setFrozenUseLoop(useLoop);
    setFrozenPerOwner(usePerOwner);
    setPayRunIndex(
      Math.max(
        0,
        getNextOpenRunIndex({
          runs: ownerPayRuns,
          orderByContract: createdOrdersRef.current.orderByContract,
          from: 0,
        }),
      ),
    );
    knownOrderIdsRef.current = readCreatedOrderIds();
    // A tenant who already has an order from this popup is never offered a
    // second one.
    setPayIndex(
      Math.max(
        0,
        getNextOpenShareIndex({
          shares: payShares,
          orderByContract: createdOrdersRef.current.orderByContract,
          from: 0,
        }),
      ),
    );
    setInnerStepIndex(0);
    setStepIdx(idx + 1);
  };

  // Back out of the payment step, only while nothing was billed: an order
  // that exists must end up on the cost.
  const leavePaymentStep = () => {
    if (hasCreatedOrders) return;
    setFrozenPayShares(undefined);
    setFrozenUseLoop(undefined);
    setFrozenPerOwner(undefined);
    setAttemptedAdvance(false);
    setStepIdx(Math.max(0, idx - 1));
  };

  // A fresh payment form: a new id (the form keeps its answers per id) and the
  // mirrored sub-step state back at the start (onStepChange does not fire on
  // mount).
  const resetPaymentForm = () => {
    setPaymentFormId(`cost-payment-${generateFormId()}`);
    setInnerStepIndex(0);
    setInnerVisibleIndex(0);
  };

  const updateStoredCost = (
    id: string,
    payload: Partial<Omit<Invoice, "id">>,
  ) => {
    if (!onUpdate) {
      throw new Error("The stored cost cannot take its payment orders");
    }
    return onUpdate(id, payload);
  };
  // The cost with every payment order created so far; the payment property's
  // cost is marked "verzonden". The first save stores the whole cost, a later
  // one only adds the new orders to its splits.
  const storeBilled = async () => {
    if (Object.keys(storedCostIdsRef.current).length === 0) {
      await shareDocumentWithStakeholders();
    }
    // A cost billed to some of its tenants before: only the splits of the
    // tenants billed now change.
    if (isPaymentLocked && initialInvoice) {
      await updateStoredCost(initialInvoice.id, {
        paymentSplits: billedRemainingSplits(),
      });
      rememberStoredCost({ key: payPropertyId, id: initialInvoice.id });
      return;
    }
    if (payPropertyId in storedCostIdsRef.current) {
      const storedId = storedCostIdsRef.current[payPropertyId];
      if (!storedId) {
        throw new Error("The stored cost has no id to add the orders to");
      }
      const { paymentSplits, paymentRequestedAt } = basePayload(
        payPropertyId,
        true,
      );
      await updateStoredCost(storedId, { paymentSplits, paymentRequestedAt });
    } else if (isEdit && initialInvoice) {
      // Editing an existing cost into a sent payment: update the one cost in
      // place (its splits carry every unit's share) instead of creating new
      // costs via onSaveMany. The cost goes first, with its splits, and their
      // payment links on their own after it: sent along with payment links,
      // the invoice details renamed those payment orders after the cost (see
      // useInvoices' update), and links alone add nothing to the cost's
      // history, so one save logs one change.
      const { paymentSplits, paymentRequestedAt, ...editedCost } = keepLevel(
        basePayload(payPropertyId, true),
      );
      await updateStoredCost(initialInvoice.id, {
        ...editedCost,
        ...(paymentSplits
          ? { paymentSplits: withoutPaymentLinks(paymentSplits) }
          : {}),
      });
      await updateStoredCost(initialInvoice.id, {
        paymentSplits,
        paymentRequestedAt,
      });
      rememberStoredCost({ key: payPropertyId, id: initialInvoice.id });
    }
    if (!isEdit) await createCostsOnce(true);
  };
  // Saving the cost failed after a payment order was created: the tenant is
  // billed, the cost does not hold the order yet. The popup stops billing and
  // says so, and saving again only stores the cost (nobody is billed twice).
  const [isSaveAfterPaymentFailed, setIsSaveAfterPaymentFailed] =
    useState(false);
  const [isStoringBilled, setIsStoringBilled] = useState(false);
  const isStoringBilledRef = useRef(false);
  // Stores the cost with every payment order created so far. It runs right
  // after each order (and again on a retry), so the orders never outlive the
  // popup without their cost (a reload, the browser's back button, a crash)
  // and the next tenant's order is added to the stored cost. Resolves
  // whether the cost holds them all.
  const persistBilled = async (): Promise<boolean> => {
    if (isStoringBilledRef.current) return false;
    isStoringBilledRef.current = true;
    setIsStoringBilled(true);
    setIsSaveAfterPaymentFailed(false);
    const orderCount = Object.keys(
      createdOrdersRef.current.orderByContract,
    ).length;
    try {
      await storeBilled();
      setStoredOrderCount(orderCount);
      return true;
    } catch (error) {
      logError({ type: EErrorType.General, error: error as Error });
      setIsSaveAfterPaymentFailed(true);
      return false;
    } finally {
      isStoringBilledRef.current = false;
      setIsStoringBilled(false);
    }
  };

  // Split the cost over the tenants who occupied the property during the period:
  // one payment order per tenant, each for their day-based share. Each share
  // carries the property it must be created against (a building cost spans
  // multiple units, each its own property). The payment description is only the
  // cost's beschrijving (no category).
  const paymentDescription = sanitizeDescription(description);
  interface PayShare {
    // The tenant's contract: what a created order is linked to.
    contractId: string;
    amount: number;
    tenantName: string;
    // Who receives the payment request. Undefined while the broker still has
    // to choose, or when the payment form decides (no lease known).
    payerId?: number;
    payerName?: string;
    propertyId?: string; // the unit/pand this payment is created against
    unitLabel?: string; // building only: which apartment
    // The stored split this share bills, for a tenant of a partly billed
    // cost (see remainingShares).
    splitId?: string;
    // The share's part of the supplier's VAT, split over all of the cost's
    // parties as the settlement splits it (see supplierVatByLease).
    supplierVat?: number;
  }
  // The share's lease, unless its tenants are not known (see
  // UNKNOWN_TENANT_SHARE_ID).
  const leaseIdOf = (share: PayShare): string | undefined =>
    share.contractId === UNKNOWN_TENANT_SHARE_ID ? undefined : share.contractId;
  // Without a lease the payment form would bill the pand's rent payer
  // unasked: it asks who pays instead (with that payer preselected).
  const askPayerOf = (share: PayShare): boolean | undefined =>
    share.contractId === UNKNOWN_TENANT_SHARE_ID || undefined;
  // The lease and the unit a share's split bills.
  const leaseOfShare = (
    share: PayShare,
  ): Pick<PaymentSplit, "contractId" | "propertyId"> => {
    const contractId = leaseIdOf(share);
    if (!contractId) return {};
    return {
      contractId,
      ...(share.propertyId ? { propertyId: Number(share.propertyId) } : {}),
    };
  };
  // Everyone on the lease who can receive its payment request.
  const payerCandidatesOf = (contractId: string): IPayerCandidate[] =>
    (
      rentalByContractId[contractId] ??
      rentalContracts.find(c => c.ref.id === contractId)
    )?.ref.payerCandidates ?? [];
  // Whom the payment form may bill: anyone on the leases of the cost's pand
  // (of its units for a group) who can receive their payment request. The
  // cost is saved after the order exists, and refuses any other payer.
  const billablePayerIds = getBillablePayerIds(
    (isBuildingCost ? buildingContracts : rentalContracts).map(
      rental => rental.ref,
    ),
  );
  // The payer of a lease's share, by the settlement's rule: the broker's
  // choice, else whoever pays the lease's rent, else its only tenant or
  // parent. Never simply the first member, which bills whoever registered on
  // Rentio first.
  const payerOfLease = (
    contractId: string,
  ): Pick<PayShare, "payerId" | "payerName"> =>
    getLeasePayer({
      candidates: payerCandidatesOf(contractId),
      chosenId: payerChoiceByContract[contractId],
    });
  const livePayShares: PayShare[] = (() => {
    if (!payPropertyId) return [];

    // Building cost → one share per unit's tenant, on that unit's own property.
    if (isBuildingCost) {
      const supplierVatOf = supplierVatByLease({
        parties: buildingResult.units.flatMap(u =>
          prorationVatParties({ unitId: u.unitId, proration: u.proration }),
        ),
        vatPct: vatPercent(vatPct),
      });
      return buildingResult.units.flatMap(u =>
        u.proration.shares
          .filter(s => s.amount > 0.005 && !fixedFeeLeases.has(s.contractId))
          .map(s => ({
            contractId: s.contractId,
            amount: s.amount,
            tenantName: s.tenantName,
            ...payerOfLease(s.contractId),
            propertyId: u.unitId,
            unitLabel: u.unitLabel,
            supplierVat: supplierVatOf[s.contractId],
          })),
      );
    }

    // Single property → day-based split over its own tenants.
    const sharePct = chargeTarget === "shared" ? tenantShare : 100;
    const res = prorateByOccupancy(
      amountFor(payPropertyId),
      sharePct,
      rentalContracts.map(c => c.ref),
      { from: periodFrom, to: periodTo },
    );
    const supplierVatOf = supplierVatByLease({
      parties: prorationVatParties({ unitId: payPropertyId, proration: res }),
      vatPct: vatPercent(vatPct),
    });
    const shares = res.shares
      .filter(s => s.amount > 0.005 && !fixedFeeLeases.has(s.contractId))
      .map(s => ({
        contractId: s.contractId,
        amount: s.amount,
        tenantName: s.tenantName,
        ...payerOfLease(s.contractId),
        propertyId: payPropertyId,
        supplierVat: supplierVatOf[s.contractId],
      }));
    // No real contracts (e.g. data still loading) → single payment for the
    // whole tenant portion; the payment form asks who pays it, with the rent
    // payer preselected (see askPayerOf). Tenants on a forfait are known
    // tenants: their share stays with the owner, nobody else pays it.
    const hasFixedFeeShares = res.shares.some(
      s => s.amount > 0.005 && fixedFeeLeases.has(s.contractId),
    );
    if (shares.length === 0 && !hasFixedFeeShares) {
      return [
        {
          contractId: UNKNOWN_TENANT_SHARE_ID,
          amount: res.tenantPortion,
          tenantName: "",
          payerId: undefined,
          propertyId: payPropertyId,
        },
      ];
    }
    return shares;
  })();
  // A cost billed to some of its tenants only (the popup was closed halfway,
  // or a payment could not be created): its other tenants can still be
  // billed, each for the share stored on the cost, on their own lease and
  // unit. A tenant whose lease cannot be told is not offered (see
  // getLeasesOfSplitsToBill).
  const remainingShares: PayShare[] = isPaymentLocked
    ? getLeasesOfSplitsToBill({
        splits: initialSplits,
        leases: (isBuildingCost ? buildingContracts : rentalContracts).map(
          rental => ({
            contractId: rental.ref.id,
            unitId: rental.ref.unitId,
            startDate: rental.ref.startDate,
            endDate: rental.ref.endDate,
            payerAccountIds: (rental.ref.payerCandidates ?? []).map(
              candidate => candidate.accountId,
            ),
          }),
        ),
        period: { from: periodFrom, to: periodTo },
      }).map(({ split, contractId, propertyId }) => ({
        contractId,
        splitId: split.id,
        amount: split.amount,
        tenantName:
          (
            rentalByContractId[contractId] ??
            rentalContracts.find(c => c.ref.id === contractId)
          )?.tenantName ?? split.payerName,
        // The payer stored on the split, while still on the lease.
        ...getLeasePayer({
          candidates: payerCandidatesOf(contractId),
          chosenId:
            payerChoiceByContract[contractId] ?? (split.payerId || undefined),
        }),
        propertyId,
        unitLabel: isBuildingCost
          ? buildingUnits.find(unit => String(unit.id) === propertyId)?.label
          : undefined,
        // The cents the popup split the supplier's VAT in when it billed the
        // other tenants (absent on older costs).
        supplierVat: split.supplierVat,
      }))
    : [];
  const canBillRemaining =
    isPaymentLocked && remainingShares.length > 0 && !!onUpdate;
  // Frozen while the payment step runs, see handleStartPayment.
  const [frozenPayShares, setFrozenPayShares] = useState<PayShare[]>();
  const payShares =
    frozenPayShares ?? (isPaymentLocked ? remainingShares : livePayShares);
  const billedShares = payShares.filter(isShareBilled);
  const openShares = payShares.filter(share => !isShareBilled(share));
  // A share's lease decides the VAT of its recharge (see leaseVat.utils): a
  // VAT-taxable lease gets the VAT the broker chose, any other lease the real
  // cost with the supplier's VAT and no VAT of our own.
  const isVatTaxableShare = (share: PayShare) =>
    !!(
      rentalByContractId[share.contractId] ??
      rentalContracts.find(c => c.ref.id === share.contractId)
    )?.ref.leaseChargesVat;
  const vatTaxableShares = payShares.filter(isVatTaxableShare);
  const paymentOfShare = (share: PayShare) =>
    costPaymentOf({
      amountExclVat: share.amount,
      supplierVatPct: vatPercent(vatPct),
      outgoingVat: isVatTaxableShare(share)
        ? outgoingVat ?? NO_OWN_VAT
        : NO_OWN_VAT,
      supplierVat: share.supplierVat,
    });
  // What a share's split records of the VAT its payment asks (see
  // PaymentSplit): the supplier's VAT it includes, or the rate it adds.
  const billedVatOfShare = (
    share: PayShare,
  ): Pick<PaymentSplit, "supplierVat" | "outgoingVatPct"> => {
    const payment = paymentOfShare(share);
    return payment.vatPct > 0
      ? { supplierVat: share.supplierVat, outgoingVatPct: payment.vatPct }
      : { supplierVat: payment.supplierVat };
  };
  // What a share's payment request asks, as the broker reads it before
  // sending: "€ 96,80 incl. € 16,80 btw van de leverancier" or
  // "€ 80,00 + 21% btw".
  const paymentLabelOfShare = (share: PayShare) => {
    const payment = paymentOfShare(share);
    if (payment.vatPct > 0) {
      return getLocalizedText("costs.payment.amount_plus_vat", {
        amount: fmtEur(payment.amount),
        rate: String(payment.vatPct),
      });
    }
    if (payment.supplierVat > 0) {
      return getLocalizedText("costs.payment.amount_incl_supplier_vat", {
        amount: fmtEur(payment.amount),
        vat: fmtEur(payment.supplierVat),
      });
    }
    return fmtEur(payment.amount);
  };
  // One payment form bills every tenant at one VAT: leases of both kinds in
  // one cost (a shop under flats) are billed one by one.
  const mixedVatRegimes =
    vatTaxableShares.length > 0 && vatTaxableShares.length < payShares.length;
  // Who a share bills: its payer, else the lease's tenants.
  const shareLabel = (share: PayShare) =>
    share.payerName ||
    share.tenantName ||
    getLocalizedText("costs.field.tenant");
  // Leases with several tenants or a parent: the broker sees who receives
  // the payment request, and chooses when no rent order says who pays.
  const payerChoiceShares = payShares.filter(share =>
    hasPayerChoice(payerCandidatesOf(share.contractId)),
  );
  const isPayerMissing = payerChoiceShares.some(share => share.payerId == null);

  // The stored splits of a partly billed cost with the tenants billed now:
  // each one's split gets its order, the payer that order bills and its lease.
  const billedRemainingSplits = (): PaymentSplit[] => {
    const { orderByContract, requestByContract, payerByContract } =
      createdOrdersRef.current;
    const billed: IBilledSplit[] = payShares.flatMap(share => {
      const orderId = orderByContract[share.contractId];
      if (orderId == null || !share.splitId) return [];
      const payerId = share.payerId ?? payerByContract[share.contractId];
      return [
        {
          splitId: share.splitId,
          orderId,
          requestId: requestByContract[share.contractId],
          payerId,
          payerName:
            getPayerName({
              candidates: payerCandidatesOf(share.contractId),
              accountId: payerId,
            }) ?? shareLabel(share),
          contractId: share.contractId,
          propertyId: share.propertyId ? Number(share.propertyId) : undefined,
          ...billedVatOfShare(share),
        },
      ];
    });
    return withBilledSplits({
      splits: initialSplits,
      billed,
      requestedAt: todayIsoDay(),
    });
  };

  // "Alles in één keer" pays every tenant to ONE chosen beneficiary. When the
  // tenants' panden have different owners that hands one owner the money of
  // another owner's tenant, so the flow then runs per tenant, where the
  // beneficiary is chosen per pand (the settlement wizard's rule). The owner
  // is the pand's; while the owners load, bulk stays off.
  const sharePropertyIds = payShares.map(share =>
    Number(share.propertyId ?? payPropertyId),
  );
  // The tenants of one pand share its owner: nothing to look up then.
  const shareOwners = usePropertyOwners(
    new Set(sharePropertyIds).size > 1 ? sharePropertyIds : [],
  );
  const mixedOwners = hasMixedOwners({
    propertyIds: sharePropertyIds,
    ownerKeyByProperty: shareOwners.keyByProperty,
    isLoaded: shareOwners.loaded,
  });
  // The "paymentOrders" step waits for them: a choice made on the
  // fail-closed guess switched the running form once they arrived.
  const isOwnerCheckPending =
    new Set(sharePropertyIds).size > 1 && !shareOwners.loaded;
  // Tenants of different owners: "Alles in één keer per eigenaar" bills each
  // owner's tenants in a form of their own, where the beneficiary is chosen
  // as in the one-owner form, and the tenants of a unit without an owner one
  // by one (see ownerPayGroups.utils). Not for leases of both VAT kinds, nor
  // while a tenant's payer is unknown: those are billed one by one anyway.
  const ownerGroups = groupSharesByOwner({
    shares: payShares,
    propertyIdOf: share => Number(share.propertyId ?? payPropertyId),
    ownerKeyByProperty: shareOwners.keyByProperty,
    nameByKey: shareOwners.nameByKey,
  });
  const ownerPayRuns = getOwnerPayRuns(ownerGroups);
  const isPerOwnerOffered =
    mixedOwners &&
    shareOwners.loaded &&
    !mixedVatRegimes &&
    !openShares.some(share => share.payerId == null) &&
    payShares.length > 1 &&
    canPayPerOwner(ownerGroups);

  // Per-tenant loop vs bulk. With multiple tenant shares the user chooses in
  // the "Betaalopdrachten aanmaken" step — also for a building/group cost:
  // bulk then submits one PaymentForm (one order + group per tenant, each on
  // the tenant's own unit), per-tenant walks the flow per unit. A building
  // with a single share always loops so that one order still gets its unit
  // attribution, and tenants of different owners always loop. So does a
  // share without a payer: only a form of its own asks for one (one form
  // asks one payer, who would then be billed for the other leases too).
  // Frozen while the payment step runs, see handleStartPayment.
  const [frozenUseLoop, setFrozenUseLoop] = useState<boolean>();
  const useLoop =
    frozenUseLoop ??
    (() => {
      if (payShares.length === 0) return false;
      if (isBuildingCost && payShares.length === 1) return true;
      if (
        mixedOwners &&
        payShares.length > 1 &&
        !(isPerOwnerOffered && paymentMode === "bulk")
      ) {
        return true;
      }
      if (mixedVatRegimes && payShares.length > 1) return true;
      if (openShares.some(share => share.payerId == null)) {
        return payShares.length > 1;
      }
      return paymentMode === "perTenant" && payShares.length > 1;
    })();

  // One form per owner instead of one for all (see isPerOwnerOffered),
  // frozen while the payment step runs like useLoop.
  const [frozenPerOwner, setFrozenPerOwner] = useState<boolean>();
  const usePerOwner = frozenPerOwner ?? (!useLoop && isPerOwnerOffered);
  // The tenants the one form bills: everyone without an order yet, or the
  // tenants of the owner whose form shows.
  const bulkShares = usePerOwner
    ? (ownerPayRuns[payRunIndex]?.shares ?? []).filter(
        share => !isShareBilled(share),
      )
    : openShares;

  // What follows once the cost holds the orders: the next tenant, or done.
  // Kept for a retry after a failed save, which goes on where it stopped.
  const afterStoredRef = useRef<() => void>(() => undefined);
  const storeBilledThen = async (next: () => void) => {
    afterStoredRef.current = next;
    if (await persistBilled()) next();
  };
  const retryPersistBilled = async () => {
    if (await persistBilled()) afterStoredRef.current();
  };

  // One tenant's payment of the per-tenant loop was created: link it, store
  // the cost with it, then go on with the next tenant without an order (after
  // this one, so a tenant whose order could not be linked is never offered a
  // second one), or close after the last.
  const handleTenantPaymentCreated = () => {
    const share = payShares[payIndex];
    if (share) captureCreatedOrders([share]);
    const nextIndex = getNextOpenShareIndex({
      shares: payShares,
      orderByContract: createdOrdersRef.current.orderByContract,
      from: payIndex + 1,
    });
    storeBilledThen(() => {
      if (nextIndex === -1) {
        onClose();
        return;
      }
      // A fresh form per payer: the form keeps its state per id, so reusing
      // it opened the next payer's payment on the previous one's last
      // sub-step, with its answers.
      resetPaymentForm();
      setPayIndex(nextIndex);
    });
  };

  // All at once: link the order of every tenant the submission billed, then
  // save the cost.
  const handleBulkPaymentCreated = (submitted: PayShare[]) => {
    captureCreatedOrders(submitted);
    storeBilledThen(onClose);
  };

  // One owner's form (or a tenant without an owner) was sent: link its
  // orders and store the cost with them, then open the next owner's form
  // that has someone to bill (never one that was sent), or close after the
  // last.
  const handleOwnerRunCreated = (submitted: PayShare[]) => {
    captureCreatedOrders(submitted);
    const nextIndex = getNextOpenRunIndex({
      runs: ownerPayRuns,
      orderByContract: createdOrdersRef.current.orderByContract,
      from: payRunIndex + 1,
    });
    storeBilledThen(() => {
      if (nextIndex === -1) {
        onClose();
        return;
      }
      // A fresh form per owner, without the previous one's answers.
      resetPaymentForm();
      setPayRunIndex(nextIndex);
    });
  };

  // A bulk submission creates the orders one tenant at a time. When a later one fails, the earlier ones exist anyway: link them,
  // tell the broker who was billed, and reopen the form for the other tenants
  // only, so a retry never bills anyone twice.
  const handleBulkPaymentFailed = (submitted: PayShare[]) => {
    const createdGroupCount: number =
      (reduxStore.getState() as any)?.PAYMENT_ORDERS_V2?.createPaymentOrders
        ?.createdGroupCount ?? 0;
    if (createdGroupCount === 0) return;
    const billed = submitted.slice(0, createdGroupCount);
    const missing = submitted.slice(createdGroupCount);
    captureCreatedOrders(billed);
    confirm({
      type: "warning",
      title: getLocalizedText("settlement.payments.partial_failure.title"),
      info: getLocalizedText("settlement.payments.partial_failure.info", {
        billed: billed.map(shareLabel).join(", "),
        missing: missing.map(shareLabel).join(", "),
      }),
    });
    resetPaymentForm();
    // The cost holds the orders that exist before anyone else is billed; the
    // fresh form then bills the others.
    storeBilledThen(() => undefined);
  };

  // The popup bills tenants now: a cost sent to its tenants right away, or
  // the tenants a partly billed cost has not billed yet.
  const billsTenants = wantsPayment || canBillRemaining;
  // "Betaalopdrachten aanmaken" step (bulk vs. per-tenant choice): whenever
  // there's more than one tenant share to bill — single pand AND building.
  const showPaymentMode = billsTenants && payShares.length > 1;
  // The same step asks who receives the payment request of a lease with
  // several tenants or a parent, also when only one lease is billed.
  const showPayerChoice = billsTenants && payerChoiceShares.length > 0;
  // And the VAT of the recharge, when a tenant still to bill has a
  // VAT-taxable lease.
  const showOutgoingVatChoice =
    billsTenants && openShares.some(isVatTaxableShare);
  const baseSteps: StepKey[] = lockedPropertyId
    ? ["info", "settlementMethod"]
    : ["info", "assignment", "settlementMethod"];
  // For a building cost we split the verdeling into two screens: first pick a
  // method + fill in its inputs, then see the pand-per-pand preview. Unit
  // costs skip straight to the preview (no method choice needed).
  const showMethodStep = showDistribution && isBuildingCost;
  // The split such a group cost is billed with, kept on the cost (see
  // basePayload). The weights are the ones the breakdown used; a key that
  // covers no unit fell back to an equal split and is not named.
  const costDistribution = showMethodStep
    ? buildCostDistribution({
        method: distributionMethod,
        key:
          distributionMethod === "key" &&
          activeKey &&
          !buildingResult.coverage.fellBackToEqual
            ? { id: activeKey.id, name: activeKey.name }
            : undefined,
        consumptionUnit,
        unitWeights: buildingResult.units.map(unit => ({
          unitId: unit.unitId,
          weight: unit.weight,
        })),
      })
    : undefined;
  const paymentSteps: StepKey[] = [
    ...(showPaymentMode || showPayerChoice || showOutgoingVatChoice
      ? (["paymentOrders"] as StepKey[])
      : []),
    "payment",
  ];
  // A cost whose payment was requested only edits its invoice details, and
  // bills the tenants it did not bill yet.
  const steps: StepKey[] = isPaymentLocked
    ? ["info", ...(canBillRemaining ? paymentSteps : [])]
    : [
        ...baseSteps,
        ...(showMethodStep ? (["distributionMethod"] as StepKey[]) : []),
        ...(showDistribution ? (["distribution"] as StepKey[]) : []),
        ...(wantsPayment ? paymentSteps : []),
      ];
  // Steps shrink when switching to "owner"; clamp so the index stays valid.
  const idx = Math.min(stepIdx, steps.length - 1);
  const stepKey = steps[idx];

  const isFirst = idx === 0;
  const isLast = idx === steps.length - 1;
  const nextIsPayment = steps[idx + 1] === "payment";
  const totalAmountForBuilding = payPropertyId ? amountFor(payPropertyId) : 0;
  const assignedAmountByUnit = buildingUnits.reduce(
    (s, u) => s + (amountByUnit[String(u.id)] ?? 0),
    0,
  );
  const totalConsumption = buildingUnits.reduce(
    (s, u) => s + (unitWeights[String(u.id)] ?? 0),
    0,
  );
  const methodStepValid = (() => {
    if (!isBuildingCost) return true;
    if (distributionMethod === "key") return !!selectedKeyId;
    if (distributionMethod === "consumption") return totalConsumption > 0;
    if (distributionMethod === "amount")
      return Math.abs(totalAmountForBuilding - assignedAmountByUnit) < 0.005;
    return true;
  })();
  const currentValid = (() => {
    if (stepKey === "info") return step1Valid;
    if (stepKey === "assignment") return step2Valid;
    if (stepKey === "settlementMethod") return step3Valid;
    if (stepKey === "distributionMethod") return methodStepValid;
    if (stepKey === "paymentOrders") {
      return (
        !isPayerMissing &&
        (!showOutgoingVatChoice || outgoingVat != null) &&
        !(showPaymentMode && isOwnerCheckPending)
      );
    }
    return true; // "distribution" is a read-only overview
  })();

  // Everything the user can fill in, to ask before throwing it away: a stray
  // "Annuleren" or X closed the popup and lost a half-entered cost. Taken once
  // when the popup opens; any difference counts as unsaved work.
  const formSnapshot = JSON.stringify({
    date,
    category,
    categoryOther,
    amount,
    vatPct,
    supplier,
    description,
    periodFrom,
    periodTo,
    selectedIds,
    equalSplit,
    manualAmounts,
    chargeTarget,
    chargeTargetChosen,
    settlementMethod,
    tenantShare,
    tenantShareFilled,
    documentId,
    selectedKeyId,
    distributionMethod,
    consumptionByUnit,
    amountByUnit,
  });
  const initialFormSnapshot = useRef(formSnapshot);
  const saveBilledAndClose = async () => {
    if (await persistBilled()) onClose();
  };
  const handleRequestClose = () => {
    // A payment is being created, or the cost stored with it: closing now
    // would leave that payment without its cost.
    if (stepKey === "payment" && (isSubmittingPayment || isStoringBilled)) {
      return;
    }
    setAttemptedAdvance(false);
    // An order exists that the cost does not hold yet (its save failed):
    // closing saves the cost with it rather than leaving the order without a
    // cost (and a retry billing that tenant again).
    if (hasUnstoredOrders) {
      confirm({
        type: "warning",
        title: getLocalizedText("costs.modal.close_with_orders.title"),
        info: getLocalizedText("costs.modal.close_with_orders.info", {
          tenants: billedShares.map(shareLabel).join(", "),
        }),
        primaryActions: [
          {
            title: getLocalizedText("costs.modal.close_with_orders.confirm"),
            onPress: () => {
              saveBilledAndClose();
            },
          },
        ],
      });
      return;
    }
    // The cost holds the orders of the tenants billed so far. The others stay
    // unbilled for now: the broker can bill them later from the cost (see
    // remainingShares).
    if (hasCreatedOrders && openShares.length > 0) {
      confirm({
        type: "warning",
        title: getLocalizedText("costs.modal.close_halfway.title"),
        info: getLocalizedText("costs.modal.close_halfway.info", {
          billed: joinRecipientNamesAmong({
            shares: billedShares,
            among: payShares,
          }),
          missing: joinRecipientNamesAmong({
            shares: openShares,
            among: payShares,
          }),
        }),
        primaryActions: [
          {
            title: getLocalizedText("costs.action.close"),
            onPress: onClose,
          },
        ],
      });
      return;
    }
    if (hasCreatedOrders) {
      onClose();
      return;
    }
    if (formSnapshot === initialFormSnapshot.current) {
      onClose();
      return;
    }
    confirm({
      type: "warning",
      title: getLocalizedText("costs.modal.discard.title"),
      info: getLocalizedText("costs.modal.discard.body"),
      primaryActions: [
        {
          title: getLocalizedText("costs.modal.discard.confirm"),
          onPress: onClose,
        },
      ],
    });
  };

  // On the way to billing the other tenants of a partly billed cost: its
  // invoice details, when corrected, are saved first and on their own (sent
  // along with payment links, they renamed those payment orders).
  const startBillingRemaining = async () => {
    if (formSnapshot !== initialFormSnapshot.current) {
      if (isSavingRef.current) return;
      isSavingRef.current = true;
      setIsSaving(true);
      try {
        await saveInvoiceDetails();
        initialFormSnapshot.current = formSnapshot;
      } catch (error) {
        logError({ type: EErrorType.General, error: error as Error });
        return;
      } finally {
        isSavingRef.current = false;
        setIsSaving(false);
      }
    }
    goToNextStep();
  };

  // On the payment step the embedded form drives its own navigation/submit —
  // unless there's nothing to collect (e.g. a fully-vacant building), in which
  // case we offer a plain save so the modal isn't stuck without buttons.
  // Volgende/Opslaan is always enabled. If the current step is invalid the
  // click sets `attemptedAdvance` so each required field renders its own red
  // inline error (Rentio convention) — the user immediately sees what's
  // missing without an opaque disabled button.
  const advanceOrShowErrors = (advance: () => void) => {
    if (currentValid) {
      setAttemptedAdvance(false);
      advance();
      return;
    }
    setAttemptedAdvance(true);
  };
  const goToNextStep = nextIsPayment
    ? handleStartPayment
    : () => setStepIdx(idx + 1);
  const buildNavActions = () => {
    const prev = isFirst
      ? {
          content: getLocalizedText("costs.action.cancel"),
          onClick: handleRequestClose,
        }
      : {
          content: getLocalizedText("costs.action.previous"),
          onClick: () => {
            setAttemptedAdvance(false);
            setStepIdx(idx - 1);
          },
        };
    const save = {
      content: getLocalizedText("costs.action.save"),
      appearance: "primary",
      isSubmitting: isSaving,
      onClick: () => advanceOrShowErrors(handleSave),
    };
    // A partly billed cost saves its corrected invoice details as usual; its
    // other tenants are billed from the banner that names them (a third
    // button did not fit next to these two).
    if (stepKey === "info" && canBillRemaining) return [prev, save];
    const next = isLast
      ? save
      : {
          content: getLocalizedText("costs.action.next"),
          appearance: "primary",
          onClick: () => advanceOrShowErrors(goToNextStep),
        };
    return [prev, next];
  };
  const handleBillRemaining = () =>
    advanceOrShowErrors(() => {
      startBillingRemaining();
    });
  // The embedded PaymentForm now hides its own footer; the cost-modal renders
  // a single, unified footer that drives the inner form via the ref. Label
  // switches to "Verzenden" on the last sub-step (the form's built-in summary).
  const isOnInnerSummary =
    paymentSchemaCount > 0 && innerStepIndex === paymentSchemaCount;
  const buildPaymentActions = () => {
    const prevClick = () => {
      setAttemptedAdvance(false);
      // Delegate to the payment form: it steps back through its own visible
      // sub-steps, and on its first visible step fires onFirstStepPrev (wired
      // below) to pop back to the previous cost step (e.g. the bulk/per-tenant
      // chooser). Fallback to a plain step-back if the ref isn't ready yet.
      if (paymentFormRef.current?.handleStepPrev) {
        paymentFormRef.current.handleStepPrev();
      } else {
        leavePaymentStep();
      }
    };
    // Once a tenant was billed, "Vorige" on the form's first step would leave
    // the payment step (and could switch "Alles in één keer"/"Per huurder"),
    // so it is gone there; within the form it still steps back.
    const isBackLocked = hasCreatedOrders && innerVisibleIndex === 0;
    return [
      ...(isBackLocked
        ? []
        : [
            {
              content: getLocalizedText("costs.action.previous"),
              onClick: prevClick,
            },
          ]),
      {
        content: getLocalizedText(
          isOnInnerSummary ? "costs.action.save" : "costs.action.next",
        ),
        appearance: "primary",
        isSubmitting: !!isSubmittingPayment,
        // On the inner summary step the form is read-only; fire the final
        // submit. Everywhere else, advance to the next step.
        onClick: () =>
          isOnInnerSummary
            ? paymentFormRef.current?.handlePressSubmit?.()
            : paymentFormRef.current?.handleExternalSubmit?.(),
      },
    ];
  };
  const actions = (() => {
    if (stepKey !== "payment") return buildNavActions();
    if (payShares.length === 0) {
      return [
        {
          content: getLocalizedText("costs.action.previous"),
          onClick: leavePaymentStep,
        },
        {
          content: getLocalizedText("costs.action.save"),
          appearance: "primary",
          isSubmitting: isSaving,
          onClick: handleSave,
        },
      ];
    }
    // The cost is being stored with the orders so far, or its save failed
    // (or every tenant has an order): saving again only stores the cost, it
    // never submits a payment again.
    if (
      isStoringBilled ||
      isSaveAfterPaymentFailed ||
      openShares.length === 0
    ) {
      return [
        {
          content: getLocalizedText("costs.action.save"),
          appearance: "primary",
          isSubmitting: isStoringBilled,
          onClick: () => {
            retryPersistBilled();
          },
        },
      ];
    }
    return buildPaymentActions();
  })();

  const handleInnerVisibleStepsChange = (
    _steps: { title: string; rawIndex: number }[],
    activeVisibleIndex: number,
  ) => setInnerVisibleIndex(activeVisibleIndex);

  // The tenants who already have a payment order from this popup: nobody is
  // offered a second one.
  const renderAlreadyBilled = () =>
    billedShares.length > 0 && (
      <Banner variation="warning" hasDismiss={false}>
        {getLocalizedText("settlement.payments.already_billed", {
          tenants: billedShares.map(shareLabel).join(", "),
        })}
      </Banner>
    );

  // Who receives the payment request of a lease with several tenants or a
  // parent, as in the settlement wizard: whoever pays the rent is
  // preselected; without a rent order the broker chooses.
  const renderPayerChoice = () => (
    <Stack vertical spacing="tight">
      <StepTitle $inStack="tight">
        <div className="left">
          <DisplayText size="small" space="none">
            {getLocalizedText("settlement.confirm.payer_title")}
          </DisplayText>
        </div>
      </StepTitle>
      <TextStyle variation="subdued">
        {getLocalizedText("settlement.confirm.payer_info")}
      </TextStyle>
      {payerChoiceShares.map(share => (
        <Select
          key={share.contractId}
          id={`cost-payer-${share.contractId}`}
          label={
            share.unitLabel
              ? `${share.tenantName} · ${share.unitLabel}`
              : share.tenantName
          }
          value={share.payerId}
          options={payerCandidatesOf(share.contractId).map(candidate => ({
            value: candidate.accountId,
            label: getPayerOptionLabel(candidate),
          }))}
          error={
            attemptedAdvance && share.payerId == null
              ? getLocalizedText("settlement.confirm.payer_missing")
              : undefined
          }
          onChange={(option: { value?: number } | null) => {
            const accountId = option?.value;
            if (accountId == null) return;
            setPayerChoiceByContract(current => ({
              ...current,
              [share.contractId]: accountId,
            }));
            // The payment form keeps its answers per form id: a fresh one
            // bills the payer chosen now.
            resetPaymentForm();
          }}
        />
      ))}
    </Stack>
  );

  // The VAT of the recharge to a VAT-taxable lease: whether the cost follows
  // the lease or is a supply of its own decides it, which Rentio cannot tell,
  // so the broker chooses (see leaseVat.utils). Nothing is preselected.
  const renderOutgoingVatChoice = () => (
    <Stack vertical spacing="tight">
      <StepTitle $inStack="tight">
        <div className="left">
          <DisplayText size="small" space="none">
            {getLocalizedText("costs.outgoing_vat.title")}
          </DisplayText>
        </div>
      </StepTitle>
      <Banner variation="warning" hasDismiss={false}>
        {getLocalizedText("costs.outgoing_vat.vat_taxable_info", {
          tenants: vatTaxableShares.map(shareLabel).join(", "),
        })}
      </Banner>
      <Select
        id="cost-outgoing-vat"
        label={getLocalizedText("costs.outgoing_vat.label")}
        value={outgoingVat}
        options={[
          {
            value: NO_OWN_VAT,
            label: getLocalizedText("costs.outgoing_vat.none"),
          },
          ...OUTGOING_VAT_RATES.map(rate => ({
            value: rate,
            label: getLocalizedText("costs.outgoing_vat.rate", {
              rate: String(rate),
            }),
          })),
        ]}
        error={
          attemptedAdvance && outgoingVat == null
            ? getLocalizedText("costs.outgoing_vat.required")
            : undefined
        }
        onChange={(option: { value?: TOutgoingVat } | null) => {
          const value = option?.value;
          if (value == null) return;
          setOutgoingVat(value);
          // The payment form keeps its answers per form id: a fresh one
          // bills the amount of the VAT chosen now.
          resetPaymentForm();
        }}
      />
    </Stack>
  );

  const inPaymentFlow = stepKey === "paymentOrders" || stepKey === "payment";
  let modalHeading = getLocalizedText(
    isEdit ? "costs.modal.edit_title" : "costs.modal.add_title",
  );
  if (inPaymentFlow)
    modalHeading = getLocalizedText("costs.modal.payment_title");

  return (
    <Modal
      heading={modalHeading}
      onClose={handleRequestClose}
      width="medium"
      actions={actions as any}
      // A stray click next to the dialog closed it and threw away every
      // field the broker filled in.
      shouldCloseOnOverlayClick={false}
    >
      {stepKey === "info" && (
        <Stack vertical spacing="loose">
          <StepTitle $inStack="loose">
            <div className="left">
              <DisplayText size="small" space="none">
                {getLocalizedText("costs.modal.step.invoice_info")}
              </DisplayText>
            </div>
          </StepTitle>

          {isPaymentLocked && (
            <Banner variation="info" hasDismiss={false}>
              {getLocalizedText("costs.modal.payment_locked_info")}
            </Banner>
          )}
          {isHeldByDeparture && (
            <Banner variation="info" hasDismiss={false}>
              <Stack vertical spacing="extraTight">
                {heldDepartureShares.map(share => (
                  <span key={share.settlementId}>
                    {getLocalizedText("costs.modal.departure_share_info", {
                      amount: fmtEur(share.amount),
                      tenant: share.tenantName,
                      until: fmtNl(share.until),
                      // The unit the tenant left, by its full address: they
                      // may rent another unit of the building now (M45).
                      unit: unitAddressOf(share.unitId),
                    })}
                  </span>
                ))}
                <span>
                  {getLocalizedText("costs.modal.departure_vat_locked")}
                </span>
              </Stack>
            </Banner>
          )}
          {canBillRemaining && (
            <Banner variation="warning" hasDismiss={false}>
              <Stack vertical spacing="tight">
                <span>
                  {getLocalizedText("costs.modal.bill_remaining.info", {
                    tenants: joinRecipientNames(remainingShares),
                  })}
                </span>
                <Button
                  appearance="outline"
                  size="small"
                  isSubmitting={isSaving}
                  onClick={handleBillRemaining}
                >
                  {getLocalizedText("costs.modal.bill_remaining.action")}
                </Button>
              </Stack>
            </Banner>
          )}

          {documentId ? (
            <UploadedFile>
              <Icon source="filePDF" />
              <span className="name">
                {documentName ?? getLocalizedText("costs.detail.invoice")}
              </span>
              <span
                className="remove"
                onClick={() => {
                  setDocumentId(undefined);
                  setDocumentName(undefined);
                }}
              >
                <Icon source="bin" />
              </span>
            </UploadedFile>
          ) : (
            <UploadZone>
              <Icon source="upload" />
              <span>
                {uploadingDoc
                  ? getLocalizedText("costs.modal.uploading")
                  : getLocalizedText("costs.modal.upload_invoice")}
              </span>
              <input
                type="file"
                accept=".pdf,.ubl,.xml,application/pdf,image/*"
                style={{ display: "none" }}
                disabled={uploadingDoc}
                onChange={e => {
                  const f = e.target.files?.[0];
                  if (!f) return;
                  setUploadingDoc(true);
                  const propertyId = Number(payPropertyId ?? fixedPropertyId);
                  // The upload util reads `path`/`type` and posts the File to S3.
                  (f as any).path = f.name;
                  dispatch(
                    documentActions.uploadDocumentStart.getAction({
                      file: f as any,
                      metaData: {
                        filename: f.name,
                        categoryId: EDocumentCategory.Invoice,
                        ...(Number.isNaN(propertyId) ? {} : { propertyId }),
                      },
                      onSuccess: (id: string) => {
                        setDocumentId(id);
                        setDocumentName(f.name);
                        setUploadingDoc(false);
                      },
                      onFailure: () => setUploadingDoc(false),
                    }),
                  );
                }}
              />
            </UploadZone>
          )}

          <Grid2>
            <IsoDateField
              id="invoice-date"
              label={getLocalizedText("costs.modal.invoice_date")}
              maxDate={today}
              error={fieldErrors.date}
              value={date}
              onChange={setDate}
            />
            <Select
              id="invoice-category"
              label={getLocalizedText("costs.field.category")}
              placeholder={getLocalizedText("costs.modal.pick_category")}
              value={category}
              options={categoryOptions}
              error={fieldErrors.category}
              disabled={isPaymentLocked}
              onChange={(opt: any) => {
                if (opt?.value) handleCategoryChange(opt.value as Category);
              }}
            />
            <LocaleNumberField
              name="invoice-amount"
              label={getLocalizedText("costs.field.amount_excl_vat")}
              suffix="€"
              isMoney
              maxDecimals={MONEY_DECIMALS}
              max={MAX_COST_AMOUNT}
              negativeMessage={getLocalizedText("costs.input.negative_amount")}
              value={amount !== 0 ? amount : undefined}
              error={fieldErrors.amount}
              disabled={isPaymentLocked}
              onChange={value => setAmount(value ?? 0)}
            />
            {/* A departure froze its VAT at this rate: a new rate would
                leave the VAT difference with no one (decision 2), so the
                rate stays, and the banner above says why. */}
            <Select
              id="invoice-vat"
              label={getLocalizedText("costs.modal.vat")}
              value={String(vatPct)}
              options={vatOptions}
              disabled={isPaymentLocked || isHeldByDeparture}
              onChange={(opt: any) =>
                setVatPct(VAT_OPTIONS.find(v => String(v) === opt.value) ?? 21)
              }
            />
          </Grid2>
          {category === "Other" && (
            <TextField
              name="invoice-category-other"
              label={getLocalizedText("costs.modal.specify_category")}
              placeholder={getLocalizedText(
                "costs.modal.description_placeholder",
              )}
              value={categoryOther}
              maxLength={MAX_COST_TEXT_LENGTH}
              error={fieldErrors.categoryOther}
              onChange={(e: any) => setCategoryOther(e.target.value)}
            />
          )}
          <AmountStack>
            <span className="amt">
              <Money amount={amount} />
            </span>
            <span className="btw">{vatLineText(incl - amount)}</span>
          </AmountStack>
          <TextField
            name="invoice-supplier"
            label={getLocalizedText("costs.field.supplier")}
            value={supplier}
            maxLength={MAX_COST_TEXT_LENGTH}
            error={fieldErrors.supplier}
            onChange={(e: any) => setSupplier(e.target.value)}
          />
          <TextField
            name="invoice-description"
            label={getLocalizedText("costs.field.description")}
            value={description}
            error={fieldErrors.description}
            onChange={(e: any) => setDescription(e.target.value)}
          />
          <div>
            <Grid2>
              <IsoDateField
                id="invoice-period-from"
                label={getLocalizedText("costs.modal.period_from")}
                value={periodFrom}
                error={fieldErrors.periodFrom}
                disabled={isPaymentLocked}
                onChange={setPeriodFrom}
              />
              <IsoDateField
                id="invoice-period-to"
                label={getLocalizedText("costs.modal.period_to")}
                minDate={periodFrom || undefined}
                value={periodTo}
                error={fieldErrors.periodTo}
                disabled={isPaymentLocked}
                onChange={setPeriodTo}
              />
            </Grid2>
            {!isPaymentLocked && (
              <PeriodPresetTabs
                name="invoice-period-preset"
                withLastMonth
                period={{ from: periodFrom, to: periodTo }}
                onSelect={(from, to) => {
                  setPeriodFrom(from);
                  setPeriodTo(to);
                }}
              />
            )}
          </div>

          {duplicateOf && (
            <Banner
              title={getLocalizedText("costs.modal.duplicate_title")}
              variation="warning"
              hasDismiss={false}
            >
              {getLocalizedText("costs.modal.duplicate_body", {
                supplier: duplicateOf.supplier,
                amount: fmtEur(duplicateOf.amountExclVat),
              })}
            </Banner>
          )}
        </Stack>
      )}

      {stepKey === "assignment" && (
        <Stack vertical spacing="loose">
          <StepTitle $inStack="loose">
            <div className="left">
              <DisplayText size="small" space="none">
                {getLocalizedText("costs.modal.step.assignment")}
              </DisplayText>
            </div>
          </StepTitle>

          <Labelled
            label={getLocalizedText("costs.modal.properties_or_groups")}
          >
            <div>
              {selectedIds.map(id => {
                const p = properties.find(x => x.id === id);
                return (
                  <SelectedRow key={id}>
                    <span className="icon">
                      <Icon source="buildings" />
                    </span>
                    <div className="body">
                      <div className="name">{p ? labelFor(p) : id}</div>
                      <div className="role">{typeLabel(p)}</div>
                    </div>
                    <DropdownMenu
                      actions={[
                        {
                          content: getLocalizedText("costs.action.delete"),
                          onClick: () =>
                            setSelectedIds(prev => prev.filter(x => x !== id)),
                        },
                      ]}
                    >
                      <span className="kebab">
                        <Icon source="navigationMenuVertical" />
                      </span>
                    </DropdownMenu>
                  </SelectedRow>
                );
              })}
            </div>
            <div style={{ marginTop: 12 }}>
              <AutocompletePopperFix />
              <PropertySelectInline
                value={undefined}
                showPropertyList={false}
                error={!!fieldErrors.properties}
                onChange={id => {
                  if (id == null) return;
                  const sid = String(id);
                  setSelectedIds(prev =>
                    prev.includes(sid) ? prev : [...prev, sid],
                  );
                }}
              />
              {fieldErrors.properties && (
                <div style={{ marginTop: 4 }}>
                  <TextStyle variation="negative">
                    {fieldErrors.properties}
                  </TextStyle>
                </div>
              )}
            </div>
          </Labelled>

          {selectedIds.length > 1 && (
            <Labelled
              label={getLocalizedText("costs.modal.step.amount_distribution")}
            >
              <div>
                <SegmentedControl
                  name="split-mode"
                  selected={equalSplit ? "equal" : "manual"}
                  options={[
                    {
                      id: "equal",
                      value: getLocalizedText("costs.modal.split.equal"),
                    },
                    {
                      id: "manual",
                      value: getLocalizedText("costs.modal.split.manual"),
                    },
                  ]}
                  onChange={(id: string) => setEqualSplit(id === "equal")}
                />
              </div>
            </Labelled>
          )}

          {selectedIds.length > 0 && (
            <>
              <div>
                {selectedIds.map(id => {
                  const p = properties.find(x => x.id === id);
                  const val = amountFor(id);
                  const pct = amount > 0 ? Math.round((val / amount) * 100) : 0;
                  return (
                    <UnitRow key={id}>
                      <span className="name">{p ? labelFor(p) : id}</span>
                      <div className="field">
                        <LocaleNumberField
                          name={`amt-${id}`}
                          suffix="€"
                          isMoney
                          maxDecimals={MONEY_DECIMALS}
                          negativeMessage={getLocalizedText(
                            "costs.input.negative_amount",
                          )}
                          disabled={equalSplit}
                          value={equalSplit ? amountFor(id) : manualAmounts[id]}
                          error={manualAmountError(id)}
                          onChange={value =>
                            setManualAmounts(m => ({
                              ...m,
                              [id]: value ?? 0,
                            }))
                          }
                        />
                      </div>
                      <span className="pct">({pct} %)</span>
                    </UnitRow>
                  );
                })}
              </div>
              <SplitHeader>
                <span className="left">
                  {getLocalizedText("costs.modal.amount_to_distribute", {
                    amount: fmtEur(amount),
                    vat: vatLabel(vatPct),
                  })}
                </span>
                <span className="total">
                  {getLocalizedText("costs.modal.total_distributed")}{" "}
                  <strong>
                    <Money amount={sumManual} size="inherit" />
                  </strong>{" "}
                  <TextStyle variation="subdued">
                    {getLocalizedText("costs.excl_vat")}
                  </TextStyle>
                </span>
              </SplitHeader>
              {/* An equal split that is a few cents off equal: say why. */}
              {equalSplit &&
                selectedIds.length > 1 &&
                isEqualSplitShiftedForVat && (
                  <TextStyle variation="subdued" size="small">
                    {getLocalizedText("costs.modal.split_equal_vat_exact", {
                      invoice_vat: fmtEur(splitVatTotals.invoiceVat),
                    })}
                  </TextStyle>
                )}
              {isSplitSumOff && (
                <Banner variation="warning" hasDismiss={false}>
                  {getLocalizedText("costs.modal.split_sum_mismatch_detail", {
                    sum: fmtEur(sumManual),
                    total: fmtEur(amount),
                  })}
                </Banner>
              )}
            </>
          )}
        </Stack>
      )}

      {stepKey === "settlementMethod" && (
        <Stack vertical spacing="loose">
          <StepTitle $inStack="loose">
            <div className="left">
              <DisplayText size="small" space="none">
                {getLocalizedText("costs.modal.step.charge_and_method")}
              </DisplayText>
            </div>
          </StepTitle>

          <Labelled
            label={getLocalizedText("costs.modal.who_bears")}
            error={fieldErrors.chargeTarget}
          >
            <OptionListShared
              id="ten-laste"
              multiple={false}
              value={chargeTargetChosen ? [chargeTarget] : []}
              options={[
                {
                  id: "tenant",
                  value: "tenant",
                  disabled: isOwnerOnlyCost,
                  label: getLocalizedText("costs.split.tenant"),
                },
                {
                  id: "owner",
                  value: "owner",
                  label: getLocalizedText("costs.split.owner"),
                },
                {
                  id: "shared",
                  value: "shared",
                  disabled: isOwnerOnlyCost,
                  label: getLocalizedText("costs.split.shared"),
                },
              ]}
              onChange={(sel: string[]) => {
                const t = (sel[0] ?? chargeTarget) as ChargeTarget;
                setChargeTarget(t);
                setChargeTargetChosen(true);
                chargeTargetTouched.current = true;
                if (t === "owner") setSettlementMethod(null);
                // Switching to "Gedeeld" seeds the category's standard tenant
                // share (Rentio's category matrix); the user can still adjust.
                // A 0% standard is not seeded: the field stays empty. A share
                // the cost already had is kept.
                if (t === "shared" && initialInvoice?.target !== "shared") {
                  const standard = category
                    ? CATEGORY_META[category]?.defaultTenantSharePct ?? 100
                    : 100;
                  setTenantShare(standard);
                  setTenantShareFilled(standard > 0);
                }
              }}
            />
          </Labelled>
          {isOwnerOnlyCost && (
            <TextStyle variation="subdued" size="small">
              {getLocalizedText("costs.modal.owner_only_hint")}
            </TextStyle>
          )}

          {chargeTarget === "shared" && (
            <div>
              <div style={{ maxWidth: 220, marginBottom: 12 }}>
                <LocaleNumberField
                  name="tenant-share"
                  label={getLocalizedText("costs.modal.tenant_share_pct")}
                  suffix="%"
                  maxDecimals={PERCENTAGE_DECIMALS}
                  max={MAX_PERCENTAGE}
                  value={tenantShareFilled ? tenantShare : undefined}
                  error={fieldErrors.tenantShare}
                  onChange={value => {
                    if (value == null) {
                      setTenantShareFilled(false);
                      return;
                    }
                    setTenantShare(value);
                    setTenantShareFilled(true);
                  }}
                />
              </div>
              {selectedIds.map(id => {
                const p = properties.find(x => x.id === id);
                const total = amountFor(id);
                // The same cent-exact split as the settlement and the
                // Verdeling step (a tie cent goes to the tenant).
                const tenantCents = tenantShareCents({
                  totalCents: toCents(total),
                  tenantSharePct: tenantShare,
                });
                const tenantAmount = fromCents(tenantCents);
                const ownerAmount = fromCents(toCents(total) - tenantCents);
                return (
                  <BreakdownRow key={id}>
                    <div className="unit">{p ? labelFor(p) : id}</div>
                    <div className="cols">
                      {/* The tenant's amount can be typed too: it sets the
                          share, rounded to the two decimals the share keeps,
                          and the field then shows what that share bills. */}
                      <LocaleNumberField
                        name={`huurder-${id}`}
                        label={getLocalizedText(
                          "costs.modal.tenant_amount_excl",
                        )}
                        suffix="€"
                        isMoney
                        maxDecimals={MONEY_DECIMALS}
                        max={total}
                        negativeMessage={getLocalizedText(
                          "costs.input.negative_amount",
                        )}
                        value={tenantShareFilled ? tenantAmount : undefined}
                        onChange={value => {
                          if (value == null || total <= 0) return;
                          setTenantShare(sharePctForAmount({ value, total }));
                          setTenantShareFilled(true);
                        }}
                      />
                      <TextField
                        name={`eigenaar-${id}`}
                        label={getLocalizedText(
                          "costs.modal.owner_amount_excl",
                        )}
                        type="text"
                        suffix="€"
                        disabled
                        value={formatNumber(ownerAmount)}
                      />
                      <div className="total">
                        <div className="lbl">
                          {getLocalizedText("costs.field.total")}
                        </div>
                        <div className="val">
                          <Money amount={total} size="inherit" />
                        </div>
                        <div className="btw">{vatLineText(btwOf(total))}</div>
                      </div>
                    </div>
                  </BreakdownRow>
                );
              })}
            </div>
          )}

          {needsReg && (
            <div>
              <Labelled
                label={getLocalizedText("costs.modal.payment_method")}
                error={fieldErrors.settlementMethod}
              >
                <OptionListShared
                  id="settlementMethod"
                  multiple={false}
                  value={settlementMethod ? [settlementMethod] : []}
                  options={[
                    {
                      id: "direct",
                      value: "direct",
                      // Grayed out, its reason under the options (see
                      // directDisabledReason).
                      disabled: !!directDisabledReason,
                      label: getLocalizedText("costs.modal.method.direct"),
                    },
                    {
                      id: "settlement",
                      value: "settlement",
                      label: getLocalizedText("costs.modal.method.settlement"),
                    },
                    {
                      id: "paid",
                      value: "paid",
                      // Grayed out after a departure, its reason under the
                      // options (the same as for "direct").
                      disabled: isHeldByDeparture,
                      // NOT "the invoice was paid to the supplier" — owners
                      // managing their own panden read it that way and would
                      // silently lose the cost from the year settlement.
                      label: getLocalizedText("costs.modal.method.paid"),
                    },
                  ]}
                  onChange={(sel: string[]) =>
                    setSettlementMethod((sel[0] as SettlementMethod) ?? null)
                  }
                />
              </Labelled>
              {/* Why an option is grayed out, in a blue card under the
                  options (Lewis, 2026-10-19). */}
              {directDisabledReason && (
                <div style={{ marginTop: 12 }}>
                  <Banner variation="info" hasDismiss={false}>
                    {directDisabledReason}
                  </Banner>
                </div>
              )}
              {settlementMethod === "paid" && (
                <TextStyle variation="subdued" size="small">
                  {getLocalizedText("costs.modal.method.paid_explainer")}
                </TextStyle>
              )}
            </div>
          )}
        </Stack>
      )}

      {stepKey === "distributionMethod" && (
        <Stack vertical spacing="loose">
          <StepTitle $inStack="loose">
            <div className="left">
              <DisplayText size="small" space="none">
                {getLocalizedText("costs.modal.step.distribution_method")}
              </DisplayText>
            </div>
          </StepTitle>
          <div style={{ marginBottom: 16 }}>
            <Banner variation="info" hasDismiss={false}>
              {getLocalizedText("costs.modal.distribution_method_intro")}
              <br />
              <br />
              {getLocalizedText("costs.modal.distribution_method_options")}
            </Banner>
          </div>
          <MethodPicker
            distributionMethod={distributionMethod}
            setDistributionMethod={setDistributionMethod}
            units={buildingUnits.map(u => ({
              id: String(u.id),
              label: u.label,
            }))}
            totalAmount={payPropertyId ? amountFor(payPropertyId) : 0}
            consumptionUnit={consumptionUnit}
            setConsumptionUnit={setConsumptionUnit}
            consumptionByUnit={consumptionByUnit}
            setConsumptionByUnit={setConsumptionByUnit}
            readingOccupantsByUnit={readingOccupantsByUnit}
            amountByUnit={amountByUnit}
            setAmountByUnit={setAmountByUnit}
            keyPicker={
              distributionMethod === "key" ? (
                <div>
                  <Select
                    id="verdeelsleutel"
                    label={getLocalizedText("costs.distribution_method.key")}
                    placeholder={getLocalizedText(
                      "costs.modal.choose_key_placeholder",
                    )}
                    value={selectedKeyId}
                    error={errIf(
                      !selectedKeyId,
                      getLocalizedText("costs.modal.choose_key_required"),
                    )}
                    options={keys.map(k => ({
                      value: k.id,
                      label: keyDisplayName(k.name),
                    }))}
                    onChange={(opt: any) =>
                      opt?.value && setSelectedKeyId(opt.value)
                    }
                  />
                </div>
              ) : null
            }
            keyActions={
              <div>
                <Button appearance="link" onClick={() => setCreatingKey(true)}>
                  {getLocalizedText("costs.keys.new")}
                </Button>
              </div>
            }
          />
          {creatingKey && (
            <KeyModal
              units={buildingUnits.map(u => ({
                id: String(u.id),
                code: u.label,
              }))}
              onClose={() => setCreatingKey(false)}
              onSave={async payload => {
                const created = await createKey({
                  groupId: buildingId ?? "",
                  isEqual: false,
                  name: payload.name ?? getLocalizedText("costs.keys.new"),
                  weights: payload.weights ?? {},
                });
                // Select the sleutel that was just made — the user created it
                // for this cost, so making them pick it again is busywork.
                if (created?.id) setSelectedKeyId(created.id);
                setCreatingKey(false);
              }}
            />
          )}
        </Stack>
      )}

      {stepKey === "distribution" && (
        <Stack vertical spacing="loose">
          <StepTitle $inStack="loose">
            <div className="left">
              <DisplayText size="small" space="none">
                {getLocalizedText("costs.modal.step.distribution")}
              </DisplayText>
            </div>
          </StepTitle>

          {isBuildingCost && distributionMethod === "key" && (
            <KeyCoverageWarning
              coverage={buildingResult.coverage}
              units={buildingUnits.map(u => ({
                id: String(u.id),
                label: u.label,
              }))}
              keyName={activeKey?.name}
            />
          )}
          <Banner variation="info" hasDismiss={false}>
            {getLocalizedText(
              distributionNoteKey({ isBuildingCost, distributionMethod }),
              { from: fmtNl(periodFrom), to: fmtNl(periodTo) },
            )}
          </Banner>
          {isBuildingCost ? (
            <BuildingDistribution
              keys={keys}
              selectedKeyId={selectedKeyId ?? activeKey?.id}
              onSelectKey={setSelectedKeyId}
              breakdown={buildingResult}
              vatRate={vatPercent(vatPct)}
              billing={costBilling}
              isShared={chargeTarget === "shared"}
              // Show which apportionment key was used (read-only) when the split
              // is key-based; hide it entirely for consumption/manual methods.
              readOnly={distributionMethod === "key"}
              hideKeyPicker={distributionMethod !== "key"}
              fixedFeeLeaseIds={fixedFeeLeases}
              occupantReadings={
                distributionMethod === "consumption"
                  ? consumptionByUnit
                  : undefined
              }
            />
          ) : (
            <>
              {selectedIds.map(id => {
                const p = properties.find(x => x.id === id);
                const label = p ? labelFor(p) : id;
                return (
                  <UnitDistribution
                    key={id}
                    propertyId={id}
                    heading={selectedIds.length > 1 ? label : undefined}
                    amount={amountFor(id)}
                    contracts={contractsForProperty(id)}
                    period={{ from: periodFrom, to: periodTo }}
                    tenantSharePct={
                      chargeTarget === "shared" ? tenantShare : undefined
                    }
                    vatRate={vatPercent(vatPct)}
                    billing={costBilling}
                    isSubtotal={selectedIds.length > 1}
                    fixedFeeLeaseIds={fixedFeeLeases}
                  />
                );
              })}

              {selectedIds.length > 1 && (
                <DistTotal>
                  <span className="lbl">
                    {getLocalizedText("costs.total_of_cost")}
                  </span>
                  <span className="val">
                    <Money amount={sumManual} size="inherit" />
                    <div className="btw">
                      {/* The panden's own VAT added up: each pand is a
                          cost of its own with its own VAT. */}
                      {vatLineText(splitVatTotals.partsVat)}
                    </div>
                  </span>
                </DistTotal>
              )}
              {/* The details step showed the invoice's VAT: say why the
                  panden pass on a cent more or less (amounts typed per
                  pand; an equal split adds up, see splitInvoiceEqually).
                  Only once the parts add up to the invoice: until then the
                  mismatch banner says what is wrong. */}
              {selectedIds.length > 1 &&
                !isSplitSumOff &&
                toCents(splitVatTotals.partsVat) !==
                  toCents(splitVatTotals.invoiceVat) && (
                  <TextStyle variation="subdued" size="small">
                    {getLocalizedText("costs.modal.split_vat_rounding", {
                      vat: fmtEur(splitVatTotals.partsVat),
                      invoice_vat: fmtEur(splitVatTotals.invoiceVat),
                    })}
                  </TextStyle>
                )}
            </>
          )}
        </Stack>
      )}

      {stepKey === "paymentOrders" &&
        !showPaymentMode &&
        showPayerChoice &&
        renderPayerChoice()}
      {stepKey === "paymentOrders" && showPaymentMode && (
        <Stack vertical spacing="tight">
          {(!mixedOwners || isPerOwnerOffered) && (
            <Banner variation="info" hasDismiss={false}>
              {getLocalizedText("costs.modal.payment_orders_info")}
              {/* Which owners "per eigenaar" means, in the same card. */}
              {isPerOwnerOffered && (
                <div style={{ marginTop: 8 }}>
                  {ownerGroupsSentence(ownerGroups)}
                </div>
              )}
            </Banner>
          )}

          <StepTitle>
            <div className="left">
              <DisplayText size="small" space="none">
                {getLocalizedText("settlement.confirm.create_orders")}
              </DisplayText>
            </div>
          </StepTitle>

          {/* Tenants of different owners are always billed one by one, so
              each pand gets its own beneficiary, and so are leases with and
              without VAT, which bill a different VAT (see useLoop). While
              the owners load (counted as different), the choice waits. */}
          {isOwnerCheckPending && (
            <TextStyle variation="subdued">
              {getLocalizedText("system.loading")}
            </TextStyle>
          )}
          {mixedOwners && !isOwnerCheckPending && !isPerOwnerOffered && (
            <Banner variation="info" hasDismiss={false}>
              {getLocalizedText("settlement.confirm.mixed_owners")}
            </Banner>
          )}
          {!mixedOwners && mixedVatRegimes && (
            <Banner variation="info" hasDismiss={false}>
              {getLocalizedText("costs.modal.mixed_vat_regimes")}
            </Banner>
          )}
          {(!mixedOwners || isPerOwnerOffered) && !mixedVatRegimes && (
            <OptionListShared
              id="payment-mode"
              multiple={false}
              value={[paymentMode]}
              options={[
                {
                  id: "bulk",
                  value: "bulk",
                  label: getLocalizedText(
                    isPerOwnerOffered
                      ? "settlement.confirm.bulk_per_owner_option"
                      : "costs.modal.pay_mode.bulk",
                  ),
                },
                {
                  id: "perTenant",
                  value: "perTenant",
                  label: getLocalizedText("costs.modal.pay_mode.per_tenant"),
                },
              ]}
              // A single-choice list reports [] when its selected option is
              // clicked again: keep the choice instead of flipping to "bulk".
              onChange={(sel: string[]) => {
                if (!sel[0]) return;
                setPaymentMode(sel[0] === "perTenant" ? "perTenant" : "bulk");
              }}
            />
          )}
          {showPayerChoice && renderPayerChoice()}
        </Stack>
      )}
      {stepKey === "paymentOrders" &&
        showOutgoingVatChoice &&
        renderOutgoingVatChoice()}

      {stepKey === "payment" && isSaveAfterPaymentFailed && (
        <Banner variation="error" hasDismiss={false}>
          {getLocalizedText("costs.modal.save_after_payment_failed")}
        </Banner>
      )}
      {stepKey === "payment" && payShares.length === 0 && (
        <Banner variation="warning" hasDismiss={false}>
          {getLocalizedText("costs.modal.no_tenants_to_collect")}
        </Banner>
      )}
      {stepKey === "payment" &&
        payShares.length > 0 &&
        (openShares.length === 0 ||
          isStoringBilled ||
          isSaveAfterPaymentFailed) &&
        renderAlreadyBilled()}
      {/* Nobody else is billed while the cost does not hold the orders that
          exist: the form returns once it does. */}
      {stepKey === "payment" &&
        openShares.length > 0 &&
        !isStoringBilled &&
        !isSaveAfterPaymentFailed &&
        (useLoop ? (
          // Per tenant — also the only path for a building, where each unit is
          // its own property. Each submission creates one payment order + its
          // own group + open payment, on that tenant's property.
          <Stack vertical spacing="loose">
            <Banner variation="info" hasDismiss={false}>
              {getLocalizedText("costs.modal.payment_progress", {
                index: String(Math.min(payIndex + 1, payShares.length)),
                total: String(payShares.length),
                tenant: payShares[payIndex]
                  ? shareLabel(payShares[payIndex])
                  : getLocalizedText("costs.field.tenant"),
              })}
              {payShares[payIndex]?.unitLabel
                ? ` · ${payShares[payIndex]?.unitLabel}`
                : ""}{" "}
              {payShares[payIndex] &&
                `(${paymentLabelOfShare(payShares[payIndex])})`}
            </Banner>
            {renderAlreadyBilled()}
            <PaymentFormContainer
              key={paymentFormId}
              inline
              formId={paymentFormId}
              onSchemaCount={setPaymentSchemaCount}
              onStepChange={setInnerStepIndex}
              onVisibleStepsChange={handleInnerVisibleStepsChange}
              formRef={paymentFormRef}
              onFirstStepPrev={leavePaymentStep}
              propertyIdOverride={
                +(payShares[payIndex]?.propertyId ?? payPropertyId ?? 0)
              }
              prefillOverride={{
                description: paymentDescription,
                // The recharge's own amount and VAT, never simply the
                // supplier's VAT (see leaseVat.utils).
                ...(payShares[payIndex]
                  ? {
                      amount: paymentOfShare(payShares[payIndex]).amount,
                      vatPct: paymentOfShare(payShares[payIndex]).vatPct,
                    }
                  : {}),
                costPayment: true,
                payerId: payShares[payIndex]?.payerId,
                payerName: payShares[payIndex]?.payerName,
                payerAccountIds: billablePayerIds,
                // On the tenant's own lease: a payer the form has to find
                // is that lease's, never another lease's rent payer.
                ...(payShares[payIndex]
                  ? {
                      contractId: leaseIdOf(payShares[payIndex]),
                      askPayer: askPayerOf(payShares[payIndex]),
                    }
                  : {}),
                // The supplier's invoice goes along with the payment request,
                // so the tenant sees what they are asked to pay for.
                documentId: documentId || undefined,
              }}
              onClose={handleTenantPaymentCreated}
            />
          </Stack>
        ) : (
          // Bulk: one submission → one payment order + own group per tenant
          // (the saga fans out the bulkGroups), each on that tenant's own
          // property. Details filled in once, for the tenants without an
          // order yet (all of them, unless a bulk submission failed halfway),
          // or for one owner's tenants at a time (usePerOwner).
          <Stack vertical spacing="loose">
            {usePerOwner && (
              <OwnerGroupList
                grouped={ownerGroups}
                currentRunIndex={payRunIndex}
                isBilled={isShareBilled}
              />
            )}
            {bulkShares.length > 1 && (
              <Banner variation="info" hasDismiss={false}>
                {getLocalizedText("costs.modal.bulk_orders_intro", {
                  count: String(bulkShares.length),
                })}
                <ul style={{ margin: "8px 0 0", paddingLeft: 18 }}>
                  {bulkShares.map(s => (
                    <li key={s.contractId}>
                      {shareLabel(s)}: {paymentLabelOfShare(s)}
                    </li>
                  ))}
                </ul>
              </Banner>
            )}
            {renderAlreadyBilled()}
            <PaymentFormContainer
              key={paymentFormId}
              inline
              formId={paymentFormId}
              onSchemaCount={setPaymentSchemaCount}
              onStepChange={setInnerStepIndex}
              onVisibleStepsChange={handleInnerVisibleStepsChange}
              formRef={paymentFormRef}
              onFirstStepPrev={leavePaymentStep}
              // The form's pand is the first tenant's own unit, not the group:
              // its beneficiary list then shows the owner of the units.
              propertyIdOverride={
                +(bulkShares[0].propertyId ?? payPropertyId ?? 0)
              }
              prefillOverride={{
                description: paymentDescription,
                amount: roundCents(
                  bulkShares.reduce(
                    (sum, s) => sum + paymentOfShare(s).amount,
                    0,
                  ),
                ),
                // Every share bills the same VAT here: leases of both kinds
                // are billed one by one (see mixedVatRegimes).
                vatPct: paymentOfShare(bulkShares[0]).vatPct,
                costPayment: true,
                payerId: bulkShares[0].payerId,
                payerName: bulkShares[0].payerName,
                payerAccountIds: billablePayerIds,
                // A single tenant goes through the plain (non-split) path,
                // which attaches this one, on their own lease.
                documentId: documentId || undefined,
                ...(bulkShares.length === 1
                  ? {
                      contractId: leaseIdOf(bulkShares[0]),
                      askPayer: askPayerOf(bulkShares[0]),
                    }
                  : {}),
                costSplits: bulkShares.map(s => ({
                  payerId: s.payerId,
                  // For the recap: the form only knows its own pand's people.
                  payerName: s.payerName,
                  unitLabel: s.unitLabel,
                  amount: paymentOfShare(s).amount,
                  // A building cost spans units, and a payment group belongs to
                  // ONE property — without this every tenant's order and open
                  // payment lands on the building instead of their own pand.
                  propertyId: s.propertyId ? Number(s.propertyId) : undefined,
                  // And to the tenant's own lease.
                  contractId: leaseIdOf(s),
                  // Every tenant's request carries the supplier's invoice.
                  documentId: documentId || undefined,
                })),
              }}
              onError={() => {
                handleBulkPaymentFailed(bulkShares);
              }}
              onClose={() => {
                if (usePerOwner) {
                  handleOwnerRunCreated(bulkShares);
                } else {
                  handleBulkPaymentCreated(bulkShares);
                }
              }}
            />
          </Stack>
        ))}
    </Modal>
  );
};

// Rentio's own currency notation ("€ 1.234,56"), the same as everywhere else,
// for a sentence that names an amount; the form shows an amount itself with
// Money.
const fmtEur = formatMoney;

const fmtNl = (iso: string) => {
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};
